import { FormlyFieldConfig } from '@ngx-formly/core';

import { SearchCriteria, ColumnInformation, PaginationSpecification } from './framework/searchObjects';

export interface IPagedResult
                {
                    PaginationInfo: PaginationSpecification;
                    TotalCount: Number;
                    Data: any[];
                }
	export class AddressDto {
		Id: number;
		Address1: string;
		Address2: string;
		Address3: string;
		City: string;
		StateId: number;
		StatesList: ValueTextDto[] = [];
		CountryId: number;
		CountriesList: CountryValueTextDto[] = [];
		Zip: string;
		IsInternational: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddress1() : FormlyFieldConfig {
			return {
			  "key": "Address1",
			  "name": "Address1",
			  "templateOptions": {
			    "label": "Address1"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddress2() : FormlyFieldConfig {
			return {
			  "key": "Address2",
			  "name": "Address2",
			  "templateOptions": {
			    "label": "Address2"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddress3() : FormlyFieldConfig {
			return {
			  "key": "Address3",
			  "name": "Address3",
			  "templateOptions": {
			    "label": "Address3"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCity() : FormlyFieldConfig {
			return {
			  "key": "City",
			  "name": "City",
			  "templateOptions": {
			    "label": "City"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStateId() : FormlyFieldConfig {
			return {
			  "key": "StateId",
			  "name": "StateId",
			  "templateOptions": {
			    "type": "number",
			    "label": "StateId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStatesList() : FormlyFieldConfig {
			return {
			  "key": "StatesList",
			  "name": "StatesList",
			  "templateOptions": {
			    "label": "StatesList",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCountryId() : FormlyFieldConfig {
			return {
			  "key": "CountryId",
			  "name": "CountryId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CountryId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCountriesList() : FormlyFieldConfig {
			return {
			  "key": "CountriesList",
			  "name": "CountriesList",
			  "templateOptions": {
			    "label": "CountriesList",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigZip() : FormlyFieldConfig {
			return {
			  "key": "Zip",
			  "name": "Zip",
			  "templateOptions": {
			    "label": "Zip"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsInternational() : FormlyFieldConfig {
			return {
			  "key": "IsInternational",
			  "name": "IsInternational",
			  "templateOptions": {
			    "label": "IsInternational"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AddressDto.FormlyConfigId,
				AddressDto.FormlyConfigAddress1,
				AddressDto.FormlyConfigAddress2,
				AddressDto.FormlyConfigAddress3,
				AddressDto.FormlyConfigCity,
				AddressDto.FormlyConfigStateId,
				AddressDto.FormlyConfigStatesList,
				AddressDto.FormlyConfigCountryId,
				AddressDto.FormlyConfigCountriesList,
				AddressDto.FormlyConfigZip,
				AddressDto.FormlyConfigIsInternational
			];
		};
	}

	export class ApplicationSettingSearchRow {
		Id: number;
		Name: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ApplicationSettingSearchRow.FormlyConfigId,
				ApplicationSettingSearchRow.FormlyConfigName
			];
		};
	}

	export class AskDataRowDto {
		Values: string[] = [];

		static get FormlyConfigValues() : FormlyFieldConfig {
			return {
			  "key": "Values",
			  "name": "Values",
			  "templateOptions": {
			    "label": "Values",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AskDataRowDto.FormlyConfigValues
			];
		};
	}

	export class AssetDto {
		AssetId: number;
		Client: ClientDto = new ClientDto();
		Name: string;
		Description: string;
		Active: boolean;

		static get FormlyConfigAssetId() : FormlyFieldConfig {
			return {
			  "key": "AssetId",
			  "name": "AssetId",
			  "templateOptions": {
			    "type": "number",
			    "label": "AssetId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigClient() : FormlyFieldConfig {
			return {
			  "key": "Client",
			  "name": "Client",
			  "templateOptions": {
			    "type": "ClientDto = new ClientDto()",
			    "label": "Client"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AssetDto.FormlyConfigAssetId,
				AssetDto.FormlyConfigClient,
				AssetDto.FormlyConfigName,
				AssetDto.FormlyConfigDescription,
				AssetDto.FormlyConfigActive
			];
		};
	}

	export class ChangedFieldDto {
		ColumnName: string;
		IsChanged: boolean;

		static get FormlyConfigColumnName() : FormlyFieldConfig {
			return {
			  "key": "ColumnName",
			  "name": "ColumnName",
			  "templateOptions": {
			    "label": "ColumnName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsChanged() : FormlyFieldConfig {
			return {
			  "key": "IsChanged",
			  "name": "IsChanged",
			  "templateOptions": {
			    "label": "IsChanged"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ChangedFieldDto.FormlyConfigColumnName,
				ChangedFieldDto.FormlyConfigIsChanged
			];
		};
	}

	export class ChangedRowDto {
		RowNumber: number;
		Id: number;
		Fields: ChangedFieldDto[] = [];

		static get FormlyConfigRowNumber() : FormlyFieldConfig {
			return {
			  "key": "RowNumber",
			  "name": "RowNumber",
			  "templateOptions": {
			    "type": "number",
			    "label": "RowNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFields() : FormlyFieldConfig {
			return {
			  "key": "Fields",
			  "name": "Fields",
			  "templateOptions": {
			    "label": "Fields",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ChangedRowDto.FormlyConfigRowNumber,
				ChangedRowDto.FormlyConfigId,
				ChangedRowDto.FormlyConfigFields
			];
		};
	}

	export class ClientDto {
		ClientId: number;
		Name: string;
		Description: string;
		Active: boolean;

		static get FormlyConfigClientId() : FormlyFieldConfig {
			return {
			  "key": "ClientId",
			  "name": "ClientId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ClientId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ClientDto.FormlyConfigClientId,
				ClientDto.FormlyConfigName,
				ClientDto.FormlyConfigDescription,
				ClientDto.FormlyConfigActive
			];
		};
	}

	export class CommandSecurityCheckpointDto {
		CommandName: string;
		HasAccess: boolean;

		static get FormlyConfigCommandName() : FormlyFieldConfig {
			return {
			  "key": "CommandName",
			  "name": "CommandName",
			  "templateOptions": {
			    "label": "CommandName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHasAccess() : FormlyFieldConfig {
			return {
			  "key": "HasAccess",
			  "name": "HasAccess",
			  "templateOptions": {
			    "label": "HasAccess"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CommandSecurityCheckpointDto.FormlyConfigCommandName,
				CommandSecurityCheckpointDto.FormlyConfigHasAccess
			];
		};
	}

	export class CommandSecurityRoleSearchRow {
		Id: number;
		SecurityCheckpointId: number;
		CommandName: string;
		Description: string;
		RoleId: number;
		Role: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSecurityCheckpointId() : FormlyFieldConfig {
			return {
			  "key": "SecurityCheckpointId",
			  "name": "SecurityCheckpointId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SecurityCheckpointId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCommandName() : FormlyFieldConfig {
			return {
			  "key": "CommandName",
			  "name": "CommandName",
			  "templateOptions": {
			    "label": "CommandName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoleId() : FormlyFieldConfig {
			return {
			  "key": "RoleId",
			  "name": "RoleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "RoleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRole() : FormlyFieldConfig {
			return {
			  "key": "Role",
			  "name": "Role",
			  "templateOptions": {
			    "label": "Role"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CommandSecurityRoleSearchRow.FormlyConfigId,
				CommandSecurityRoleSearchRow.FormlyConfigSecurityCheckpointId,
				CommandSecurityRoleSearchRow.FormlyConfigCommandName,
				CommandSecurityRoleSearchRow.FormlyConfigDescription,
				CommandSecurityRoleSearchRow.FormlyConfigRoleId,
				CommandSecurityRoleSearchRow.FormlyConfigRole
			];
		};
	}

	export class CompanyDto {
		CompanyId: number;
		Name: string;

		static get FormlyConfigCompanyId() : FormlyFieldConfig {
			return {
			  "key": "CompanyId",
			  "name": "CompanyId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompanyId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CompanyDto.FormlyConfigCompanyId,
				CompanyDto.FormlyConfigName
			];
		};
	}

	export class CountryDto {
		Id: number;
		Name: string;
		IsInternational: boolean;
		IsActive: boolean = true;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsInternational() : FormlyFieldConfig {
			return {
			  "key": "IsInternational",
			  "name": "IsInternational",
			  "templateOptions": {
			    "label": "IsInternational"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountryDto.FormlyConfigId,
				CountryDto.FormlyConfigName,
				CountryDto.FormlyConfigIsInternational,
				CountryDto.FormlyConfigIsActive
			];
		};
	}

	export class CountrySearchRow {
		Id: number;
		Name: string;
		IsActive: boolean = true;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountrySearchRow.FormlyConfigId,
				CountrySearchRow.FormlyConfigName,
				CountrySearchRow.FormlyConfigIsActive
			];
		};
	}

	export class CountryValueTextDto {
		Value: number;
		IsInternational: boolean;
		Text: string;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsInternational() : FormlyFieldConfig {
			return {
			  "key": "IsInternational",
			  "name": "IsInternational",
			  "templateOptions": {
			    "label": "IsInternational"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountryValueTextDto.FormlyConfigValue,
				CountryValueTextDto.FormlyConfigIsInternational,
				CountryValueTextDto.FormlyConfigText
			];
		};
	}

	export class CountWidgetDto {
		ReferenceName: string;
		DisplayName: string;
		ViewName: string;
		Link: string;
		Count: number;
		Id: number;
		Order: number;
		WidgetType: WidgetType;
		Selected: boolean;

		static get FormlyConfigReferenceName() : FormlyFieldConfig {
			return {
			  "key": "ReferenceName",
			  "name": "ReferenceName",
			  "templateOptions": {
			    "label": "ReferenceName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayName() : FormlyFieldConfig {
			return {
			  "key": "DisplayName",
			  "name": "DisplayName",
			  "templateOptions": {
			    "label": "DisplayName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigViewName() : FormlyFieldConfig {
			return {
			  "key": "ViewName",
			  "name": "ViewName",
			  "templateOptions": {
			    "label": "ViewName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLink() : FormlyFieldConfig {
			return {
			  "key": "Link",
			  "name": "Link",
			  "templateOptions": {
			    "label": "Link"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCount() : FormlyFieldConfig {
			return {
			  "key": "Count",
			  "name": "Count",
			  "templateOptions": {
			    "type": "number",
			    "label": "Count"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWidgetType() : FormlyFieldConfig {
			return {
			  "key": "WidgetType",
			  "name": "WidgetType",
			  "templateOptions": {
			    "type": "WidgetType = new WidgetType()",
			    "label": "WidgetType",
			    "options": [
			      {
			        "label": "Count",
			        "value": "0"
			      }
			    ]
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CountWidgetDto.FormlyConfigReferenceName,
				CountWidgetDto.FormlyConfigDisplayName,
				CountWidgetDto.FormlyConfigViewName,
				CountWidgetDto.FormlyConfigLink,
				CountWidgetDto.FormlyConfigCount,
				CountWidgetDto.FormlyConfigId,
				CountWidgetDto.FormlyConfigOrder,
				CountWidgetDto.FormlyConfigWidgetType,
				CountWidgetDto.FormlyConfigSelected
			];
		};
	}

	export class DashboardDto {
		Widgets: WidgetDto[] = [];

		static get FormlyConfigWidgets() : FormlyFieldConfig {
			return {
			  "key": "Widgets",
			  "name": "Widgets",
			  "templateOptions": {
			    "label": "Widgets",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DashboardDto.FormlyConfigWidgets
			];
		};
	}

	export class DateDto {
		Day: number;
		Month: number;
		Year: number;

		static get FormlyConfigDay() : FormlyFieldConfig {
			return {
			  "key": "Day",
			  "name": "Day",
			  "templateOptions": {
			    "type": "number",
			    "label": "Day"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMonth() : FormlyFieldConfig {
			return {
			  "key": "Month",
			  "name": "Month",
			  "templateOptions": {
			    "type": "number",
			    "label": "Month"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigYear() : FormlyFieldConfig {
			return {
			  "key": "Year",
			  "name": "Year",
			  "templateOptions": {
			    "type": "number",
			    "label": "Year"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DateDto.FormlyConfigDay,
				DateDto.FormlyConfigMonth,
				DateDto.FormlyConfigYear
			];
		};
	}

	export class ErrorLogSearchRow {
		Id: number;
		CreationDate: Date;
		ApplicationName: string;
		URL: string;
		User: string;
		EnvironmentInfo: string;
		Message: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreationDate() : FormlyFieldConfig {
			return {
			  "key": "CreationDate",
			  "name": "CreationDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreationDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigApplicationName() : FormlyFieldConfig {
			return {
			  "key": "ApplicationName",
			  "name": "ApplicationName",
			  "templateOptions": {
			    "label": "ApplicationName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigURL() : FormlyFieldConfig {
			return {
			  "key": "URL",
			  "name": "URL",
			  "templateOptions": {
			    "label": "URL"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUser() : FormlyFieldConfig {
			return {
			  "key": "User",
			  "name": "User",
			  "templateOptions": {
			    "label": "User"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEnvironmentInfo() : FormlyFieldConfig {
			return {
			  "key": "EnvironmentInfo",
			  "name": "EnvironmentInfo",
			  "templateOptions": {
			    "label": "EnvironmentInfo"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMessage() : FormlyFieldConfig {
			return {
			  "key": "Message",
			  "name": "Message",
			  "templateOptions": {
			    "label": "Message"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ErrorLogSearchRow.FormlyConfigId,
				ErrorLogSearchRow.FormlyConfigCreationDate,
				ErrorLogSearchRow.FormlyConfigApplicationName,
				ErrorLogSearchRow.FormlyConfigURL,
				ErrorLogSearchRow.FormlyConfigUser,
				ErrorLogSearchRow.FormlyConfigEnvironmentInfo,
				ErrorLogSearchRow.FormlyConfigMessage
			];
		};
	}

	export class ExampleSearchRow {
		Id: number;
		CreateDate: Date;
		Key: string;
		DisplayText: string;
		Value: string;
		ExampleLookupDisplayText: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreateDate() : FormlyFieldConfig {
			return {
			  "key": "CreateDate",
			  "name": "CreateDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreateDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigKey() : FormlyFieldConfig {
			return {
			  "key": "Key",
			  "name": "Key",
			  "templateOptions": {
			    "label": "Key"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayText() : FormlyFieldConfig {
			return {
			  "key": "DisplayText",
			  "name": "DisplayText",
			  "templateOptions": {
			    "label": "DisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExampleLookupDisplayText() : FormlyFieldConfig {
			return {
			  "key": "ExampleLookupDisplayText",
			  "name": "ExampleLookupDisplayText",
			  "templateOptions": {
			    "label": "ExampleLookupDisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExampleSearchRow.FormlyConfigId,
				ExampleSearchRow.FormlyConfigCreateDate,
				ExampleSearchRow.FormlyConfigKey,
				ExampleSearchRow.FormlyConfigDisplayText,
				ExampleSearchRow.FormlyConfigValue,
				ExampleSearchRow.FormlyConfigExampleLookupDisplayText
			];
		};
	}

	export class ExecutionBarChartDto {
		LastActivityDate: Date;
		BaselineManHoursTotal: number;
		BaselineManHoursToDate: number;
		AtCompletionManHoursTotal: number;
		ActualManHoursTotal: number;
		ActualPercentComplete: number;
		BaselinePercentComplete: number;
		ProjectedPercentComplete: number;

		static get FormlyConfigLastActivityDate() : FormlyFieldConfig {
			return {
			  "key": "LastActivityDate",
			  "name": "LastActivityDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "LastActivityDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineManHoursTotal() : FormlyFieldConfig {
			return {
			  "key": "BaselineManHoursTotal",
			  "name": "BaselineManHoursTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "BaselineManHoursTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineManHoursToDate() : FormlyFieldConfig {
			return {
			  "key": "BaselineManHoursToDate",
			  "name": "BaselineManHoursToDate",
			  "templateOptions": {
			    "type": "number",
			    "label": "BaselineManHoursToDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAtCompletionManHoursTotal() : FormlyFieldConfig {
			return {
			  "key": "AtCompletionManHoursTotal",
			  "name": "AtCompletionManHoursTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "AtCompletionManHoursTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActualManHoursTotal() : FormlyFieldConfig {
			return {
			  "key": "ActualManHoursTotal",
			  "name": "ActualManHoursTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "ActualManHoursTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActualPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "ActualPercentComplete",
			  "name": "ActualPercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "ActualPercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselinePercentComplete() : FormlyFieldConfig {
			return {
			  "key": "BaselinePercentComplete",
			  "name": "BaselinePercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "BaselinePercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectedPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "ProjectedPercentComplete",
			  "name": "ProjectedPercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectedPercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionBarChartDto.FormlyConfigLastActivityDate,
				ExecutionBarChartDto.FormlyConfigBaselineManHoursTotal,
				ExecutionBarChartDto.FormlyConfigBaselineManHoursToDate,
				ExecutionBarChartDto.FormlyConfigAtCompletionManHoursTotal,
				ExecutionBarChartDto.FormlyConfigActualManHoursTotal,
				ExecutionBarChartDto.FormlyConfigActualPercentComplete,
				ExecutionBarChartDto.FormlyConfigBaselinePercentComplete,
				ExecutionBarChartDto.FormlyConfigProjectedPercentComplete
			];
		};
	}

	export class ExecutionChartDataDto {
		name: string;
		series: ExecutionChartDataSeriesDto[] = [];

		static get FormlyConfigname() : FormlyFieldConfig {
			return {
			  "key": "name",
			  "name": "name",
			  "templateOptions": {
			    "label": "name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigseries() : FormlyFieldConfig {
			return {
			  "key": "series",
			  "name": "series",
			  "templateOptions": {
			    "label": "series",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionChartDataDto.FormlyConfigname,
				ExecutionChartDataDto.FormlyConfigseries
			];
		};
	}

	export class ExecutionChartDataSeriesDto {
		name: string;
		value: number;

		static get FormlyConfigname() : FormlyFieldConfig {
			return {
			  "key": "name",
			  "name": "name",
			  "templateOptions": {
			    "label": "name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigvalue() : FormlyFieldConfig {
			return {
			  "key": "value",
			  "name": "value",
			  "templateOptions": {
			    "type": "number",
			    "label": "value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionChartDataSeriesDto.FormlyConfigname,
				ExecutionChartDataSeriesDto.FormlyConfigvalue
			];
		};
	}

	export class ExecutionScheduleDto {
		ChartData: ExecutionChartDataDto[] = [];

		static get FormlyConfigChartData() : FormlyFieldConfig {
			return {
			  "key": "ChartData",
			  "name": "ChartData",
			  "templateOptions": {
			    "label": "ChartData",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionScheduleDto.FormlyConfigChartData
			];
		};
	}

	export class ExecutionSummaryDto {
		TotalItems: number;
		PercentComplete: number;
		ExecutionAccessUrl: string;
		TimeEntryAccessUrl: string;
		ProjectStatusReportUrl: string;
		BaselineFinishDate: string;
		ProjectFinishDate: string;
		ProjectedStartDate: string;
		ProjectDataDate: string;
		ExecutionWbsLevels: SummaryStageDto[] = [];

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExecutionAccessUrl() : FormlyFieldConfig {
			return {
			  "key": "ExecutionAccessUrl",
			  "name": "ExecutionAccessUrl",
			  "templateOptions": {
			    "label": "ExecutionAccessUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeEntryAccessUrl() : FormlyFieldConfig {
			return {
			  "key": "TimeEntryAccessUrl",
			  "name": "TimeEntryAccessUrl",
			  "templateOptions": {
			    "label": "TimeEntryAccessUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectStatusReportUrl() : FormlyFieldConfig {
			return {
			  "key": "ProjectStatusReportUrl",
			  "name": "ProjectStatusReportUrl",
			  "templateOptions": {
			    "label": "ProjectStatusReportUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineFinishDate() : FormlyFieldConfig {
			return {
			  "key": "BaselineFinishDate",
			  "name": "BaselineFinishDate",
			  "templateOptions": {
			    "label": "BaselineFinishDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectFinishDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectFinishDate",
			  "name": "ProjectFinishDate",
			  "templateOptions": {
			    "label": "ProjectFinishDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectedStartDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectedStartDate",
			  "name": "ProjectedStartDate",
			  "templateOptions": {
			    "label": "ProjectedStartDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectDataDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectDataDate",
			  "name": "ProjectDataDate",
			  "templateOptions": {
			    "label": "ProjectDataDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExecutionWbsLevels() : FormlyFieldConfig {
			return {
			  "key": "ExecutionWbsLevels",
			  "name": "ExecutionWbsLevels",
			  "templateOptions": {
			    "label": "ExecutionWbsLevels",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutionSummaryDto.FormlyConfigTotalItems,
				ExecutionSummaryDto.FormlyConfigPercentComplete,
				ExecutionSummaryDto.FormlyConfigExecutionAccessUrl,
				ExecutionSummaryDto.FormlyConfigTimeEntryAccessUrl,
				ExecutionSummaryDto.FormlyConfigProjectStatusReportUrl,
				ExecutionSummaryDto.FormlyConfigBaselineFinishDate,
				ExecutionSummaryDto.FormlyConfigProjectFinishDate,
				ExecutionSummaryDto.FormlyConfigProjectedStartDate,
				ExecutionSummaryDto.FormlyConfigProjectDataDate,
				ExecutionSummaryDto.FormlyConfigExecutionWbsLevels
			];
		};
	}

	export class FabricationDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				FabricationDto.FormlyConfigId,
				FabricationDto.FormlyConfigDescription,
				FabricationDto.FormlyConfigValue,
				FabricationDto.FormlyConfigWeight,
				FabricationDto.FormlyConfigIsActive,
				FabricationDto.FormlyConfigModifiedByUserId,
				FabricationDto.FormlyConfigModifiedDate
			];
		};
	}

	export class FileDto {
		Bytes: Blob;
		Base64String: string;
		Name: string;
		MimeType: string;

		static get FormlyConfigBytes() : FormlyFieldConfig {
			return {
			  "key": "Bytes",
			  "name": "Bytes",
			  "templateOptions": {
			    "label": "Bytes",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigBase64String() : FormlyFieldConfig {
			return {
			  "key": "Base64String",
			  "name": "Base64String",
			  "templateOptions": {
			    "label": "Base64String"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMimeType() : FormlyFieldConfig {
			return {
			  "key": "MimeType",
			  "name": "MimeType",
			  "templateOptions": {
			    "label": "MimeType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				FileDto.FormlyConfigBytes,
				FileDto.FormlyConfigBase64String,
				FileDto.FormlyConfigName,
				FileDto.FormlyConfigMimeType
			];
		};
	}

	export class HeightAccessDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				HeightAccessDto.FormlyConfigId,
				HeightAccessDto.FormlyConfigDescription,
				HeightAccessDto.FormlyConfigValue,
				HeightAccessDto.FormlyConfigWeight,
				HeightAccessDto.FormlyConfigIsActive,
				HeightAccessDto.FormlyConfigModifiedByUserId,
				HeightAccessDto.FormlyConfigModifiedDate
			];
		};
	}

	export class IntegrationSettingValue {
		IntegrationName: string;
		SettingValue: string;

		static get FormlyConfigIntegrationName() : FormlyFieldConfig {
			return {
			  "key": "IntegrationName",
			  "name": "IntegrationName",
			  "templateOptions": {
			    "label": "IntegrationName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSettingValue() : FormlyFieldConfig {
			return {
			  "key": "SettingValue",
			  "name": "SettingValue",
			  "templateOptions": {
			    "label": "SettingValue"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				IntegrationSettingValue.FormlyConfigIntegrationName,
				IntegrationSettingValue.FormlyConfigSettingValue
			];
		};
	}

	export class IsolationPlanDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				IsolationPlanDto.FormlyConfigId,
				IsolationPlanDto.FormlyConfigDescription,
				IsolationPlanDto.FormlyConfigValue,
				IsolationPlanDto.FormlyConfigWeight,
				IsolationPlanDto.FormlyConfigIsActive,
				IsolationPlanDto.FormlyConfigModifiedByUserId,
				IsolationPlanDto.FormlyConfigModifiedDate
			];
		};
	}

	export class LinkDto {
		id: number;
		type: string;
		source: number;
		target: number;

		static get FormlyConfigid() : FormlyFieldConfig {
			return {
			  "key": "id",
			  "name": "id",
			  "templateOptions": {
			    "type": "number",
			    "label": "id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtype() : FormlyFieldConfig {
			return {
			  "key": "type",
			  "name": "type",
			  "templateOptions": {
			    "label": "type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigsource() : FormlyFieldConfig {
			return {
			  "key": "source",
			  "name": "source",
			  "templateOptions": {
			    "type": "number",
			    "label": "source"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtarget() : FormlyFieldConfig {
			return {
			  "key": "target",
			  "name": "target",
			  "templateOptions": {
			    "type": "number",
			    "label": "target"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LinkDto.FormlyConfigid,
				LinkDto.FormlyConfigtype,
				LinkDto.FormlyConfigsource,
				LinkDto.FormlyConfigtarget
			];
		};
	}

	export class MaterialsPhaseDto {
		PhaseId: number;
		PhaseName: string;
		TotalItems: number;
		PercentComplete: number;

		static get FormlyConfigPhaseId() : FormlyFieldConfig {
			return {
			  "key": "PhaseId",
			  "name": "PhaseId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PhaseId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPhaseName() : FormlyFieldConfig {
			return {
			  "key": "PhaseName",
			  "name": "PhaseName",
			  "templateOptions": {
			    "label": "PhaseName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialsPhaseDto.FormlyConfigPhaseId,
				MaterialsPhaseDto.FormlyConfigPhaseName,
				MaterialsPhaseDto.FormlyConfigTotalItems,
				MaterialsPhaseDto.FormlyConfigPercentComplete
			];
		};
	}

	export class MaterialsSchemaDto {
		SchemaId: number;
		SchemaName: string;
		TotalItems: number;
		PercentComplete: number;
		MaterialsPhases: MaterialsPhaseDto[] = [];

		static get FormlyConfigSchemaId() : FormlyFieldConfig {
			return {
			  "key": "SchemaId",
			  "name": "SchemaId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SchemaId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSchemaName() : FormlyFieldConfig {
			return {
			  "key": "SchemaName",
			  "name": "SchemaName",
			  "templateOptions": {
			    "label": "SchemaName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsPhases() : FormlyFieldConfig {
			return {
			  "key": "MaterialsPhases",
			  "name": "MaterialsPhases",
			  "templateOptions": {
			    "label": "MaterialsPhases",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialsSchemaDto.FormlyConfigSchemaId,
				MaterialsSchemaDto.FormlyConfigSchemaName,
				MaterialsSchemaDto.FormlyConfigTotalItems,
				MaterialsSchemaDto.FormlyConfigPercentComplete,
				MaterialsSchemaDto.FormlyConfigMaterialsPhases
			];
		};
	}

	export class MaterialsStageStatusDto {
		TotalItems: number;
		PercentComplete: number;
		MaterialsAccessUrl: string;
		MaterialsSchemas: MaterialsSchemaDto[] = [];

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsAccessUrl() : FormlyFieldConfig {
			return {
			  "key": "MaterialsAccessUrl",
			  "name": "MaterialsAccessUrl",
			  "templateOptions": {
			    "label": "MaterialsAccessUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsSchemas() : FormlyFieldConfig {
			return {
			  "key": "MaterialsSchemas",
			  "name": "MaterialsSchemas",
			  "templateOptions": {
			    "label": "MaterialsSchemas",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialsStageStatusDto.FormlyConfigTotalItems,
				MaterialsStageStatusDto.FormlyConfigPercentComplete,
				MaterialsStageStatusDto.FormlyConfigMaterialsAccessUrl,
				MaterialsStageStatusDto.FormlyConfigMaterialsSchemas
			];
		};
	}

	export class MaterialStatusDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MaterialStatusDto.FormlyConfigId,
				MaterialStatusDto.FormlyConfigDescription,
				MaterialStatusDto.FormlyConfigValue,
				MaterialStatusDto.FormlyConfigWeight,
				MaterialStatusDto.FormlyConfigIsActive,
				MaterialStatusDto.FormlyConfigModifiedByUserId,
				MaterialStatusDto.FormlyConfigModifiedDate
			];
		};
	}

	export class MOCStatusDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MOCStatusDto.FormlyConfigId,
				MOCStatusDto.FormlyConfigDescription,
				MOCStatusDto.FormlyConfigValue,
				MOCStatusDto.FormlyConfigWeight,
				MOCStatusDto.FormlyConfigIsActive,
				MOCStatusDto.FormlyConfigModifiedByUserId,
				MOCStatusDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ModuleDisplaySettingDto {
		DisplayReadiness: boolean;
		DisplayMaterials: boolean;
		DisplayExecution: boolean;

		static get FormlyConfigDisplayReadiness() : FormlyFieldConfig {
			return {
			  "key": "DisplayReadiness",
			  "name": "DisplayReadiness",
			  "templateOptions": {
			    "label": "DisplayReadiness"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigDisplayMaterials() : FormlyFieldConfig {
			return {
			  "key": "DisplayMaterials",
			  "name": "DisplayMaterials",
			  "templateOptions": {
			    "label": "DisplayMaterials"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigDisplayExecution() : FormlyFieldConfig {
			return {
			  "key": "DisplayExecution",
			  "name": "DisplayExecution",
			  "templateOptions": {
			    "label": "DisplayExecution"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ModuleDisplaySettingDto.FormlyConfigDisplayReadiness,
				ModuleDisplaySettingDto.FormlyConfigDisplayMaterials,
				ModuleDisplaySettingDto.FormlyConfigDisplayExecution
			];
		};
	}

	export class NewReadinessTaskAttachmentDto {
		FileName: string;
		FileType: string;
		Source: string;
		Base64Data: string;
		BlobUrl: string;
		IsTaskImage: boolean;

		static get FormlyConfigFileName() : FormlyFieldConfig {
			return {
			  "key": "FileName",
			  "name": "FileName",
			  "templateOptions": {
			    "label": "FileName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileType() : FormlyFieldConfig {
			return {
			  "key": "FileType",
			  "name": "FileType",
			  "templateOptions": {
			    "label": "FileType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSource() : FormlyFieldConfig {
			return {
			  "key": "Source",
			  "name": "Source",
			  "templateOptions": {
			    "label": "Source"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBase64Data() : FormlyFieldConfig {
			return {
			  "key": "Base64Data",
			  "name": "Base64Data",
			  "templateOptions": {
			    "label": "Base64Data"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBlobUrl() : FormlyFieldConfig {
			return {
			  "key": "BlobUrl",
			  "name": "BlobUrl",
			  "templateOptions": {
			    "label": "BlobUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsTaskImage() : FormlyFieldConfig {
			return {
			  "key": "IsTaskImage",
			  "name": "IsTaskImage",
			  "templateOptions": {
			    "label": "IsTaskImage"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				NewReadinessTaskAttachmentDto.FormlyConfigFileName,
				NewReadinessTaskAttachmentDto.FormlyConfigFileType,
				NewReadinessTaskAttachmentDto.FormlyConfigSource,
				NewReadinessTaskAttachmentDto.FormlyConfigBase64Data,
				NewReadinessTaskAttachmentDto.FormlyConfigBlobUrl,
				NewReadinessTaskAttachmentDto.FormlyConfigIsTaskImage
			];
		};
	}

	export class PagedResponse {
		Pager: Pager = new Pager();
		Data: vw_UserSessionDto[] = [];

		static get FormlyConfigPager() : FormlyFieldConfig {
			return {
			  "key": "Pager",
			  "name": "Pager",
			  "templateOptions": {
			    "type": "Pager = new Pager()",
			    "label": "Pager"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigData() : FormlyFieldConfig {
			return {
			  "key": "Data",
			  "name": "Data",
			  "templateOptions": {
			    "label": "Data",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				PagedResponse.FormlyConfigPager,
				PagedResponse.FormlyConfigData
			];
		};
	}

	export class Pager {
		CurrentPage: number;
		PageSize: number;
		TotalItems: number;

		static get FormlyConfigCurrentPage() : FormlyFieldConfig {
			return {
			  "key": "CurrentPage",
			  "name": "CurrentPage",
			  "templateOptions": {
			    "type": "number",
			    "label": "CurrentPage"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPageSize() : FormlyFieldConfig {
			return {
			  "key": "PageSize",
			  "name": "PageSize",
			  "templateOptions": {
			    "type": "number",
			    "label": "PageSize"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				Pager.FormlyConfigCurrentPage,
				Pager.FormlyConfigPageSize,
				Pager.FormlyConfigTotalItems
			];
		};
	}

	export class PriorityDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				PriorityDto.FormlyConfigId,
				PriorityDto.FormlyConfigDescription,
				PriorityDto.FormlyConfigValue,
				PriorityDto.FormlyConfigWeight,
				PriorityDto.FormlyConfigIsActive,
				PriorityDto.FormlyConfigModifiedByUserId,
				PriorityDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectAccessDto {
		Username: string;
		TimeIn: Date;
		TimeZone: string;
		ProjectId: number;
		Name: string;
		Description: string;
		LastAccessedOn: Date;
		TotalAccessCount: number;
		TotalTimeSpent: string;
		AreaBreakdown: ProjectAreaTimeDto[] = [];

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeIn() : FormlyFieldConfig {
			return {
			  "key": "TimeIn",
			  "name": "TimeIn",
			  "templateOptions": {
			    "type": "Date",
			    "label": "TimeIn"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeZone() : FormlyFieldConfig {
			return {
			  "key": "TimeZone",
			  "name": "TimeZone",
			  "templateOptions": {
			    "label": "TimeZone"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastAccessedOn() : FormlyFieldConfig {
			return {
			  "key": "LastAccessedOn",
			  "name": "LastAccessedOn",
			  "templateOptions": {
			    "type": "Date",
			    "label": "LastAccessedOn"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalAccessCount() : FormlyFieldConfig {
			return {
			  "key": "TotalAccessCount",
			  "name": "TotalAccessCount",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalAccessCount"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalTimeSpent() : FormlyFieldConfig {
			return {
			  "key": "TotalTimeSpent",
			  "name": "TotalTimeSpent",
			  "templateOptions": {
			    "label": "TotalTimeSpent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAreaBreakdown() : FormlyFieldConfig {
			return {
			  "key": "AreaBreakdown",
			  "name": "AreaBreakdown",
			  "templateOptions": {
			    "label": "AreaBreakdown",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectAccessDto.FormlyConfigUsername,
				ProjectAccessDto.FormlyConfigTimeIn,
				ProjectAccessDto.FormlyConfigTimeZone,
				ProjectAccessDto.FormlyConfigProjectId,
				ProjectAccessDto.FormlyConfigName,
				ProjectAccessDto.FormlyConfigDescription,
				ProjectAccessDto.FormlyConfigLastAccessedOn,
				ProjectAccessDto.FormlyConfigTotalAccessCount,
				ProjectAccessDto.FormlyConfigTotalTimeSpent,
				ProjectAccessDto.FormlyConfigAreaBreakdown
			];
		};
	}

	export class ProjectAccessPagedResponse {
		Pager: Pager = new Pager();
		Data: ProjectAccessDto[] = [];

		static get FormlyConfigPager() : FormlyFieldConfig {
			return {
			  "key": "Pager",
			  "name": "Pager",
			  "templateOptions": {
			    "type": "Pager = new Pager()",
			    "label": "Pager"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigData() : FormlyFieldConfig {
			return {
			  "key": "Data",
			  "name": "Data",
			  "templateOptions": {
			    "label": "Data",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectAccessPagedResponse.FormlyConfigPager,
				ProjectAccessPagedResponse.FormlyConfigData
			];
		};
	}

	export class ProjectAreaTimeDto {
		AccessArea: string;
		TotalMinutes: number;
		TotalTimeSpent: string;
		AccessCount: number;
		LastAccessedOn: Date;

		static get FormlyConfigAccessArea() : FormlyFieldConfig {
			return {
			  "key": "AccessArea",
			  "name": "AccessArea",
			  "templateOptions": {
			    "label": "AccessArea"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalMinutes() : FormlyFieldConfig {
			return {
			  "key": "TotalMinutes",
			  "name": "TotalMinutes",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalMinutes"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalTimeSpent() : FormlyFieldConfig {
			return {
			  "key": "TotalTimeSpent",
			  "name": "TotalTimeSpent",
			  "templateOptions": {
			    "label": "TotalTimeSpent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAccessCount() : FormlyFieldConfig {
			return {
			  "key": "AccessCount",
			  "name": "AccessCount",
			  "templateOptions": {
			    "type": "number",
			    "label": "AccessCount"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastAccessedOn() : FormlyFieldConfig {
			return {
			  "key": "LastAccessedOn",
			  "name": "LastAccessedOn",
			  "templateOptions": {
			    "type": "Date",
			    "label": "LastAccessedOn"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectAreaTimeDto.FormlyConfigAccessArea,
				ProjectAreaTimeDto.FormlyConfigTotalMinutes,
				ProjectAreaTimeDto.FormlyConfigTotalTimeSpent,
				ProjectAreaTimeDto.FormlyConfigAccessCount,
				ProjectAreaTimeDto.FormlyConfigLastAccessedOn
			];
		};
	}

	export class ProjectCardMetricsDto {
		ProjectId: number;
		ReadyPercent: number;
		MaterialsPercent: number;
		ExecutionPercent: number;
		CommPercent: number;
		ProjectDataDate: string;
		BaselineFinishDate: string;
		ProjectFinishDate: string;
		IsStale: boolean;
		AsOf: string;
		CommAsOf: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigReadyPercent() : FormlyFieldConfig {
			return {
			  "key": "ReadyPercent",
			  "name": "ReadyPercent",
			  "templateOptions": {
			    "type": "number",
			    "label": "ReadyPercent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialsPercent() : FormlyFieldConfig {
			return {
			  "key": "MaterialsPercent",
			  "name": "MaterialsPercent",
			  "templateOptions": {
			    "type": "number",
			    "label": "MaterialsPercent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExecutionPercent() : FormlyFieldConfig {
			return {
			  "key": "ExecutionPercent",
			  "name": "ExecutionPercent",
			  "templateOptions": {
			    "type": "number",
			    "label": "ExecutionPercent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCommPercent() : FormlyFieldConfig {
			return {
			  "key": "CommPercent",
			  "name": "CommPercent",
			  "templateOptions": {
			    "type": "number",
			    "label": "CommPercent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectDataDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectDataDate",
			  "name": "ProjectDataDate",
			  "templateOptions": {
			    "label": "ProjectDataDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBaselineFinishDate() : FormlyFieldConfig {
			return {
			  "key": "BaselineFinishDate",
			  "name": "BaselineFinishDate",
			  "templateOptions": {
			    "label": "BaselineFinishDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectFinishDate() : FormlyFieldConfig {
			return {
			  "key": "ProjectFinishDate",
			  "name": "ProjectFinishDate",
			  "templateOptions": {
			    "label": "ProjectFinishDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsStale() : FormlyFieldConfig {
			return {
			  "key": "IsStale",
			  "name": "IsStale",
			  "templateOptions": {
			    "label": "IsStale"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigAsOf() : FormlyFieldConfig {
			return {
			  "key": "AsOf",
			  "name": "AsOf",
			  "templateOptions": {
			    "label": "AsOf"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCommAsOf() : FormlyFieldConfig {
			return {
			  "key": "CommAsOf",
			  "name": "CommAsOf",
			  "templateOptions": {
			    "label": "CommAsOf"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectCardMetricsDto.FormlyConfigProjectId,
				ProjectCardMetricsDto.FormlyConfigReadyPercent,
				ProjectCardMetricsDto.FormlyConfigMaterialsPercent,
				ProjectCardMetricsDto.FormlyConfigExecutionPercent,
				ProjectCardMetricsDto.FormlyConfigCommPercent,
				ProjectCardMetricsDto.FormlyConfigProjectDataDate,
				ProjectCardMetricsDto.FormlyConfigBaselineFinishDate,
				ProjectCardMetricsDto.FormlyConfigProjectFinishDate,
				ProjectCardMetricsDto.FormlyConfigIsStale,
				ProjectCardMetricsDto.FormlyConfigAsOf,
				ProjectCardMetricsDto.FormlyConfigCommAsOf
			];
		};
	}

	export class ProjectDto {
		ProjectId: number;
		Asset: AssetDto = new AssetDto();
		Client: ClientDto = new ClientDto();
		Name: string;
		Description: string;
		Active: boolean;
		PrimaveraIdentifiers: string[] = [];
		SiteSenseIdentifiers: string[] = [];
		ClientIdentifiers: string[] = [];
		CXPlannerIdentifiers: string[] = [];
		ReadinessAssessmentPath: string;
		IsReadinessFormEnabled: boolean;
		DisplayReadiness: boolean;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAsset() : FormlyFieldConfig {
			return {
			  "key": "Asset",
			  "name": "Asset",
			  "templateOptions": {
			    "type": "AssetDto = new AssetDto()",
			    "label": "Asset"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigClient() : FormlyFieldConfig {
			return {
			  "key": "Client",
			  "name": "Client",
			  "templateOptions": {
			    "type": "ClientDto = new ClientDto()",
			    "label": "Client"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigPrimaveraIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "PrimaveraIdentifiers",
			  "name": "PrimaveraIdentifiers",
			  "templateOptions": {
			    "label": "PrimaveraIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigSiteSenseIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "SiteSenseIdentifiers",
			  "name": "SiteSenseIdentifiers",
			  "templateOptions": {
			    "label": "SiteSenseIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigClientIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "ClientIdentifiers",
			  "name": "ClientIdentifiers",
			  "templateOptions": {
			    "label": "ClientIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCXPlannerIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "CXPlannerIdentifiers",
			  "name": "CXPlannerIdentifiers",
			  "templateOptions": {
			    "label": "CXPlannerIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigReadinessAssessmentPath() : FormlyFieldConfig {
			return {
			  "key": "ReadinessAssessmentPath",
			  "name": "ReadinessAssessmentPath",
			  "templateOptions": {
			    "label": "ReadinessAssessmentPath"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsReadinessFormEnabled() : FormlyFieldConfig {
			return {
			  "key": "IsReadinessFormEnabled",
			  "name": "IsReadinessFormEnabled",
			  "templateOptions": {
			    "label": "IsReadinessFormEnabled"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigDisplayReadiness() : FormlyFieldConfig {
			return {
			  "key": "DisplayReadiness",
			  "name": "DisplayReadiness",
			  "templateOptions": {
			    "label": "DisplayReadiness"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectDto.FormlyConfigProjectId,
				ProjectDto.FormlyConfigAsset,
				ProjectDto.FormlyConfigClient,
				ProjectDto.FormlyConfigName,
				ProjectDto.FormlyConfigDescription,
				ProjectDto.FormlyConfigActive,
				ProjectDto.FormlyConfigPrimaveraIdentifiers,
				ProjectDto.FormlyConfigSiteSenseIdentifiers,
				ProjectDto.FormlyConfigClientIdentifiers,
				ProjectDto.FormlyConfigCXPlannerIdentifiers,
				ProjectDto.FormlyConfigReadinessAssessmentPath,
				ProjectDto.FormlyConfigIsReadinessFormEnabled,
				ProjectDto.FormlyConfigDisplayReadiness
			];
		};
	}

	export class ProjectFabricationDto {
		ProjectFabricationId: number;
		ProjectId: number;
		FabricationId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectFabricationId() : FormlyFieldConfig {
			return {
			  "key": "ProjectFabricationId",
			  "name": "ProjectFabricationId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectFabricationId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFabricationId() : FormlyFieldConfig {
			return {
			  "key": "FabricationId",
			  "name": "FabricationId",
			  "templateOptions": {
			    "type": "number",
			    "label": "FabricationId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectFabricationDto.FormlyConfigProjectFabricationId,
				ProjectFabricationDto.FormlyConfigProjectId,
				ProjectFabricationDto.FormlyConfigFabricationId,
				ProjectFabricationDto.FormlyConfigOrder,
				ProjectFabricationDto.FormlyConfigCreated,
				ProjectFabricationDto.FormlyConfigModified,
				ProjectFabricationDto.FormlyConfigId,
				ProjectFabricationDto.FormlyConfigDescription,
				ProjectFabricationDto.FormlyConfigValue,
				ProjectFabricationDto.FormlyConfigWeight,
				ProjectFabricationDto.FormlyConfigIsActive,
				ProjectFabricationDto.FormlyConfigModifiedByUserId,
				ProjectFabricationDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectHeightAccessDto {
		ProjectHeightAccessId: number;
		ProjectId: number;
		HeightAccessId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectHeightAccessId() : FormlyFieldConfig {
			return {
			  "key": "ProjectHeightAccessId",
			  "name": "ProjectHeightAccessId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectHeightAccessId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHeightAccessId() : FormlyFieldConfig {
			return {
			  "key": "HeightAccessId",
			  "name": "HeightAccessId",
			  "templateOptions": {
			    "type": "number",
			    "label": "HeightAccessId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectHeightAccessDto.FormlyConfigProjectHeightAccessId,
				ProjectHeightAccessDto.FormlyConfigProjectId,
				ProjectHeightAccessDto.FormlyConfigHeightAccessId,
				ProjectHeightAccessDto.FormlyConfigOrder,
				ProjectHeightAccessDto.FormlyConfigCreated,
				ProjectHeightAccessDto.FormlyConfigModified,
				ProjectHeightAccessDto.FormlyConfigId,
				ProjectHeightAccessDto.FormlyConfigDescription,
				ProjectHeightAccessDto.FormlyConfigValue,
				ProjectHeightAccessDto.FormlyConfigWeight,
				ProjectHeightAccessDto.FormlyConfigIsActive,
				ProjectHeightAccessDto.FormlyConfigModifiedByUserId,
				ProjectHeightAccessDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectIsolationPlanDto {
		ProjectIsolationPlanId: number;
		ProjectId: number;
		IsolationPlanId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectIsolationPlanId() : FormlyFieldConfig {
			return {
			  "key": "ProjectIsolationPlanId",
			  "name": "ProjectIsolationPlanId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectIsolationPlanId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsolationPlanId() : FormlyFieldConfig {
			return {
			  "key": "IsolationPlanId",
			  "name": "IsolationPlanId",
			  "templateOptions": {
			    "type": "number",
			    "label": "IsolationPlanId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectIsolationPlanDto.FormlyConfigProjectIsolationPlanId,
				ProjectIsolationPlanDto.FormlyConfigProjectId,
				ProjectIsolationPlanDto.FormlyConfigIsolationPlanId,
				ProjectIsolationPlanDto.FormlyConfigOrder,
				ProjectIsolationPlanDto.FormlyConfigCreated,
				ProjectIsolationPlanDto.FormlyConfigModified,
				ProjectIsolationPlanDto.FormlyConfigId,
				ProjectIsolationPlanDto.FormlyConfigDescription,
				ProjectIsolationPlanDto.FormlyConfigValue,
				ProjectIsolationPlanDto.FormlyConfigWeight,
				ProjectIsolationPlanDto.FormlyConfigIsActive,
				ProjectIsolationPlanDto.FormlyConfigModifiedByUserId,
				ProjectIsolationPlanDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectMaterialStatusDto {
		ProjectMaterialStatusId: number;
		ProjectId: number;
		MaterialStatusId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectMaterialStatusId() : FormlyFieldConfig {
			return {
			  "key": "ProjectMaterialStatusId",
			  "name": "ProjectMaterialStatusId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectMaterialStatusId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialStatusId() : FormlyFieldConfig {
			return {
			  "key": "MaterialStatusId",
			  "name": "MaterialStatusId",
			  "templateOptions": {
			    "type": "number",
			    "label": "MaterialStatusId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectMaterialStatusDto.FormlyConfigProjectMaterialStatusId,
				ProjectMaterialStatusDto.FormlyConfigProjectId,
				ProjectMaterialStatusDto.FormlyConfigMaterialStatusId,
				ProjectMaterialStatusDto.FormlyConfigOrder,
				ProjectMaterialStatusDto.FormlyConfigCreated,
				ProjectMaterialStatusDto.FormlyConfigModified,
				ProjectMaterialStatusDto.FormlyConfigId,
				ProjectMaterialStatusDto.FormlyConfigDescription,
				ProjectMaterialStatusDto.FormlyConfigValue,
				ProjectMaterialStatusDto.FormlyConfigWeight,
				ProjectMaterialStatusDto.FormlyConfigIsActive,
				ProjectMaterialStatusDto.FormlyConfigModifiedByUserId,
				ProjectMaterialStatusDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectMOCStatusDto {
		ProjectMOCStatusId: number;
		ProjectId: number;
		MOCStatusId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectMOCStatusId() : FormlyFieldConfig {
			return {
			  "key": "ProjectMOCStatusId",
			  "name": "ProjectMOCStatusId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectMOCStatusId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCStatusId() : FormlyFieldConfig {
			return {
			  "key": "MOCStatusId",
			  "name": "MOCStatusId",
			  "templateOptions": {
			    "type": "number",
			    "label": "MOCStatusId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectMOCStatusDto.FormlyConfigProjectMOCStatusId,
				ProjectMOCStatusDto.FormlyConfigProjectId,
				ProjectMOCStatusDto.FormlyConfigMOCStatusId,
				ProjectMOCStatusDto.FormlyConfigOrder,
				ProjectMOCStatusDto.FormlyConfigCreated,
				ProjectMOCStatusDto.FormlyConfigModified,
				ProjectMOCStatusDto.FormlyConfigId,
				ProjectMOCStatusDto.FormlyConfigDescription,
				ProjectMOCStatusDto.FormlyConfigValue,
				ProjectMOCStatusDto.FormlyConfigWeight,
				ProjectMOCStatusDto.FormlyConfigIsActive,
				ProjectMOCStatusDto.FormlyConfigModifiedByUserId,
				ProjectMOCStatusDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectPhaseDto {
		ProjectPhaseId: number;
		PhaseName: string;
		PhaseDescription: string;
		Created: Date;
		Active: boolean;

		static get FormlyConfigProjectPhaseId() : FormlyFieldConfig {
			return {
			  "key": "ProjectPhaseId",
			  "name": "ProjectPhaseId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectPhaseId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPhaseName() : FormlyFieldConfig {
			return {
			  "key": "PhaseName",
			  "name": "PhaseName",
			  "templateOptions": {
			    "label": "PhaseName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPhaseDescription() : FormlyFieldConfig {
			return {
			  "key": "PhaseDescription",
			  "name": "PhaseDescription",
			  "templateOptions": {
			    "label": "PhaseDescription"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectPhaseDto.FormlyConfigProjectPhaseId,
				ProjectPhaseDto.FormlyConfigPhaseName,
				ProjectPhaseDto.FormlyConfigPhaseDescription,
				ProjectPhaseDto.FormlyConfigCreated,
				ProjectPhaseDto.FormlyConfigActive
			];
		};
	}

	export class ProjectPriorityDto {
		ProjectPriorityId: number;
		ProjectId: number;
		PriorityId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectPriorityId() : FormlyFieldConfig {
			return {
			  "key": "ProjectPriorityId",
			  "name": "ProjectPriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectPriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityId() : FormlyFieldConfig {
			return {
			  "key": "PriorityId",
			  "name": "PriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectPriorityDto.FormlyConfigProjectPriorityId,
				ProjectPriorityDto.FormlyConfigProjectId,
				ProjectPriorityDto.FormlyConfigPriorityId,
				ProjectPriorityDto.FormlyConfigOrder,
				ProjectPriorityDto.FormlyConfigCreated,
				ProjectPriorityDto.FormlyConfigModified,
				ProjectPriorityDto.FormlyConfigId,
				ProjectPriorityDto.FormlyConfigDescription,
				ProjectPriorityDto.FormlyConfigValue,
				ProjectPriorityDto.FormlyConfigWeight,
				ProjectPriorityDto.FormlyConfigIsActive,
				ProjectPriorityDto.FormlyConfigModifiedByUserId,
				ProjectPriorityDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectPrioritySummaryDto {
		Project: ProjectDto = new ProjectDto();
		SummaryPriorities: SummaryPriorityDto[] = [];

		static get FormlyConfigProject() : FormlyFieldConfig {
			return {
			  "key": "Project",
			  "name": "Project",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "Project"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSummaryPriorities() : FormlyFieldConfig {
			return {
			  "key": "SummaryPriorities",
			  "name": "SummaryPriorities",
			  "templateOptions": {
			    "label": "SummaryPriorities",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectPrioritySummaryDto.FormlyConfigProject,
				ProjectPrioritySummaryDto.FormlyConfigSummaryPriorities
			];
		};
	}

	export class ProjectRevDto {
		ProjectRevId: number;
		ProjectId: number;
		RevId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectRevId() : FormlyFieldConfig {
			return {
			  "key": "ProjectRevId",
			  "name": "ProjectRevId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectRevId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRevId() : FormlyFieldConfig {
			return {
			  "key": "RevId",
			  "name": "RevId",
			  "templateOptions": {
			    "type": "number",
			    "label": "RevId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectRevDto.FormlyConfigProjectRevId,
				ProjectRevDto.FormlyConfigProjectId,
				ProjectRevDto.FormlyConfigRevId,
				ProjectRevDto.FormlyConfigOrder,
				ProjectRevDto.FormlyConfigCreated,
				ProjectRevDto.FormlyConfigModified,
				ProjectRevDto.FormlyConfigId,
				ProjectRevDto.FormlyConfigDescription,
				ProjectRevDto.FormlyConfigValue,
				ProjectRevDto.FormlyConfigWeight,
				ProjectRevDto.FormlyConfigIsActive,
				ProjectRevDto.FormlyConfigModifiedByUserId,
				ProjectRevDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectSetupDto {
		Id: number;
		ProPakProject: ProjectDto = new ProjectDto();
		ReadinessAssessmentPath: string;
		PrimaveraIdentifiers: string[] = [];
		SiteSenseIdentifiers: string[] = [];
		ClientIdentifiers: string[] = [];
		CXPlannerIdentifiers: string[] = [];
		UserRoles: UserRoleDto[] = [];
		PowerBiReportPath: string;
		ProjectDisplayType: string;
		ShowProjected: boolean;
		MasterReport: string;
		ActivitiesDisplayType: string;
		ShowFullSchedule: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProPakProject() : FormlyFieldConfig {
			return {
			  "key": "ProPakProject",
			  "name": "ProPakProject",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "ProPakProject"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigReadinessAssessmentPath() : FormlyFieldConfig {
			return {
			  "key": "ReadinessAssessmentPath",
			  "name": "ReadinessAssessmentPath",
			  "templateOptions": {
			    "label": "ReadinessAssessmentPath"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPrimaveraIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "PrimaveraIdentifiers",
			  "name": "PrimaveraIdentifiers",
			  "templateOptions": {
			    "label": "PrimaveraIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigSiteSenseIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "SiteSenseIdentifiers",
			  "name": "SiteSenseIdentifiers",
			  "templateOptions": {
			    "label": "SiteSenseIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigClientIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "ClientIdentifiers",
			  "name": "ClientIdentifiers",
			  "templateOptions": {
			    "label": "ClientIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCXPlannerIdentifiers() : FormlyFieldConfig {
			return {
			  "key": "CXPlannerIdentifiers",
			  "name": "CXPlannerIdentifiers",
			  "templateOptions": {
			    "label": "CXPlannerIdentifiers",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigUserRoles() : FormlyFieldConfig {
			return {
			  "key": "UserRoles",
			  "name": "UserRoles",
			  "templateOptions": {
			    "label": "UserRoles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigPowerBiReportPath() : FormlyFieldConfig {
			return {
			  "key": "PowerBiReportPath",
			  "name": "PowerBiReportPath",
			  "templateOptions": {
			    "label": "PowerBiReportPath"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectDisplayType() : FormlyFieldConfig {
			return {
			  "key": "ProjectDisplayType",
			  "name": "ProjectDisplayType",
			  "templateOptions": {
			    "label": "ProjectDisplayType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigShowProjected() : FormlyFieldConfig {
			return {
			  "key": "ShowProjected",
			  "name": "ShowProjected",
			  "templateOptions": {
			    "label": "ShowProjected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigMasterReport() : FormlyFieldConfig {
			return {
			  "key": "MasterReport",
			  "name": "MasterReport",
			  "templateOptions": {
			    "label": "MasterReport"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActivitiesDisplayType() : FormlyFieldConfig {
			return {
			  "key": "ActivitiesDisplayType",
			  "name": "ActivitiesDisplayType",
			  "templateOptions": {
			    "label": "ActivitiesDisplayType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigShowFullSchedule() : FormlyFieldConfig {
			return {
			  "key": "ShowFullSchedule",
			  "name": "ShowFullSchedule",
			  "templateOptions": {
			    "label": "ShowFullSchedule"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectSetupDto.FormlyConfigId,
				ProjectSetupDto.FormlyConfigProPakProject,
				ProjectSetupDto.FormlyConfigReadinessAssessmentPath,
				ProjectSetupDto.FormlyConfigPrimaveraIdentifiers,
				ProjectSetupDto.FormlyConfigSiteSenseIdentifiers,
				ProjectSetupDto.FormlyConfigClientIdentifiers,
				ProjectSetupDto.FormlyConfigCXPlannerIdentifiers,
				ProjectSetupDto.FormlyConfigUserRoles,
				ProjectSetupDto.FormlyConfigPowerBiReportPath,
				ProjectSetupDto.FormlyConfigProjectDisplayType,
				ProjectSetupDto.FormlyConfigShowProjected,
				ProjectSetupDto.FormlyConfigMasterReport,
				ProjectSetupDto.FormlyConfigActivitiesDisplayType,
				ProjectSetupDto.FormlyConfigShowFullSchedule
			];
		};
	}

	export class ProjectStagedOnSiteDto {
		ProjectStagedOnSiteId: number;
		ProjectId: number;
		StagedOnSiteId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectStagedOnSiteId() : FormlyFieldConfig {
			return {
			  "key": "ProjectStagedOnSiteId",
			  "name": "ProjectStagedOnSiteId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectStagedOnSiteId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStagedOnSiteId() : FormlyFieldConfig {
			return {
			  "key": "StagedOnSiteId",
			  "name": "StagedOnSiteId",
			  "templateOptions": {
			    "type": "number",
			    "label": "StagedOnSiteId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectStagedOnSiteDto.FormlyConfigProjectStagedOnSiteId,
				ProjectStagedOnSiteDto.FormlyConfigProjectId,
				ProjectStagedOnSiteDto.FormlyConfigStagedOnSiteId,
				ProjectStagedOnSiteDto.FormlyConfigOrder,
				ProjectStagedOnSiteDto.FormlyConfigCreated,
				ProjectStagedOnSiteDto.FormlyConfigModified,
				ProjectStagedOnSiteDto.FormlyConfigId,
				ProjectStagedOnSiteDto.FormlyConfigDescription,
				ProjectStagedOnSiteDto.FormlyConfigValue,
				ProjectStagedOnSiteDto.FormlyConfigWeight,
				ProjectStagedOnSiteDto.FormlyConfigIsActive,
				ProjectStagedOnSiteDto.FormlyConfigModifiedByUserId,
				ProjectStagedOnSiteDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectTARApprovalDto {
		ProjectTARApprovalId: number;
		ProjectId: number;
		TARApprovalId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectTARApprovalId() : FormlyFieldConfig {
			return {
			  "key": "ProjectTARApprovalId",
			  "name": "ProjectTARApprovalId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectTARApprovalId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTARApprovalId() : FormlyFieldConfig {
			return {
			  "key": "TARApprovalId",
			  "name": "TARApprovalId",
			  "templateOptions": {
			    "type": "number",
			    "label": "TARApprovalId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectTARApprovalDto.FormlyConfigProjectTARApprovalId,
				ProjectTARApprovalDto.FormlyConfigProjectId,
				ProjectTARApprovalDto.FormlyConfigTARApprovalId,
				ProjectTARApprovalDto.FormlyConfigOrder,
				ProjectTARApprovalDto.FormlyConfigCreated,
				ProjectTARApprovalDto.FormlyConfigModified,
				ProjectTARApprovalDto.FormlyConfigId,
				ProjectTARApprovalDto.FormlyConfigDescription,
				ProjectTARApprovalDto.FormlyConfigValue,
				ProjectTARApprovalDto.FormlyConfigWeight,
				ProjectTARApprovalDto.FormlyConfigIsActive,
				ProjectTARApprovalDto.FormlyConfigModifiedByUserId,
				ProjectTARApprovalDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ProjectWorkPackRequiredDto {
		ProjectWorkPackRequiredId: number;
		ProjectId: number;
		WorkPackRequiredId: number;
		Order: number;
		Created: Date;
		Modified: Date;
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigProjectWorkPackRequiredId() : FormlyFieldConfig {
			return {
			  "key": "ProjectWorkPackRequiredId",
			  "name": "ProjectWorkPackRequiredId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectWorkPackRequiredId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWorkPackRequiredId() : FormlyFieldConfig {
			return {
			  "key": "WorkPackRequiredId",
			  "name": "WorkPackRequiredId",
			  "templateOptions": {
			    "type": "number",
			    "label": "WorkPackRequiredId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreated() : FormlyFieldConfig {
			return {
			  "key": "Created",
			  "name": "Created",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Created"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModified() : FormlyFieldConfig {
			return {
			  "key": "Modified",
			  "name": "Modified",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Modified"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ProjectWorkPackRequiredDto.FormlyConfigProjectWorkPackRequiredId,
				ProjectWorkPackRequiredDto.FormlyConfigProjectId,
				ProjectWorkPackRequiredDto.FormlyConfigWorkPackRequiredId,
				ProjectWorkPackRequiredDto.FormlyConfigOrder,
				ProjectWorkPackRequiredDto.FormlyConfigCreated,
				ProjectWorkPackRequiredDto.FormlyConfigModified,
				ProjectWorkPackRequiredDto.FormlyConfigId,
				ProjectWorkPackRequiredDto.FormlyConfigDescription,
				ProjectWorkPackRequiredDto.FormlyConfigValue,
				ProjectWorkPackRequiredDto.FormlyConfigWeight,
				ProjectWorkPackRequiredDto.FormlyConfigIsActive,
				ProjectWorkPackRequiredDto.FormlyConfigModifiedByUserId,
				ProjectWorkPackRequiredDto.FormlyConfigModifiedDate
			];
		};
	}

	export class ReadinessCategoryStatusDto {
		CategoryId: number;
		CategoryName: string;
		TaskCountSatisfied: number;
		TaskCountInProgress: number;
		TaskCountInComplete: number;
		TaskCountTotal: number;
		StatusPercentage: number;
		ScorePercent: number;
		PercentComplete: number;
		PercentInProgress: number;
		PercentIncomplete: number;

		static get FormlyConfigCategoryId() : FormlyFieldConfig {
			return {
			  "key": "CategoryId",
			  "name": "CategoryId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CategoryId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCategoryName() : FormlyFieldConfig {
			return {
			  "key": "CategoryName",
			  "name": "CategoryName",
			  "templateOptions": {
			    "label": "CategoryName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountSatisfied() : FormlyFieldConfig {
			return {
			  "key": "TaskCountSatisfied",
			  "name": "TaskCountSatisfied",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountSatisfied"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountInProgress() : FormlyFieldConfig {
			return {
			  "key": "TaskCountInProgress",
			  "name": "TaskCountInProgress",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountInProgress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountInComplete() : FormlyFieldConfig {
			return {
			  "key": "TaskCountInComplete",
			  "name": "TaskCountInComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountInComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStatusPercentage() : FormlyFieldConfig {
			return {
			  "key": "StatusPercentage",
			  "name": "StatusPercentage",
			  "templateOptions": {
			    "type": "number",
			    "label": "StatusPercentage"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigScorePercent() : FormlyFieldConfig {
			return {
			  "key": "ScorePercent",
			  "name": "ScorePercent",
			  "templateOptions": {
			    "type": "number",
			    "label": "ScorePercent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentInProgress() : FormlyFieldConfig {
			return {
			  "key": "PercentInProgress",
			  "name": "PercentInProgress",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentInProgress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentIncomplete() : FormlyFieldConfig {
			return {
			  "key": "PercentIncomplete",
			  "name": "PercentIncomplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentIncomplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessCategoryStatusDto.FormlyConfigCategoryId,
				ReadinessCategoryStatusDto.FormlyConfigCategoryName,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountSatisfied,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountInProgress,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountInComplete,
				ReadinessCategoryStatusDto.FormlyConfigTaskCountTotal,
				ReadinessCategoryStatusDto.FormlyConfigStatusPercentage,
				ReadinessCategoryStatusDto.FormlyConfigScorePercent,
				ReadinessCategoryStatusDto.FormlyConfigPercentComplete,
				ReadinessCategoryStatusDto.FormlyConfigPercentInProgress,
				ReadinessCategoryStatusDto.FormlyConfigPercentIncomplete
			];
		};
	}

	export class ReadinessColumnDataDto {
		ReadinessColumnDataId: number;
		ColumnName: string;
		DisplayName: string;
		ColumnType: string;
		IsVisible: boolean;
		IsRequired: boolean;
		RequiredInFormula: boolean;
		ColumnOrder: number;
		SectionOrder: number;
		SectionName: string;
		ProjectId: number;
		Value: number;

		static get FormlyConfigReadinessColumnDataId() : FormlyFieldConfig {
			return {
			  "key": "ReadinessColumnDataId",
			  "name": "ReadinessColumnDataId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ReadinessColumnDataId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigColumnName() : FormlyFieldConfig {
			return {
			  "key": "ColumnName",
			  "name": "ColumnName",
			  "templateOptions": {
			    "label": "ColumnName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayName() : FormlyFieldConfig {
			return {
			  "key": "DisplayName",
			  "name": "DisplayName",
			  "templateOptions": {
			    "label": "DisplayName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigColumnType() : FormlyFieldConfig {
			return {
			  "key": "ColumnType",
			  "name": "ColumnType",
			  "templateOptions": {
			    "label": "ColumnType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsVisible() : FormlyFieldConfig {
			return {
			  "key": "IsVisible",
			  "name": "IsVisible",
			  "templateOptions": {
			    "label": "IsVisible"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIsRequired() : FormlyFieldConfig {
			return {
			  "key": "IsRequired",
			  "name": "IsRequired",
			  "templateOptions": {
			    "label": "IsRequired"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigRequiredInFormula() : FormlyFieldConfig {
			return {
			  "key": "RequiredInFormula",
			  "name": "RequiredInFormula",
			  "templateOptions": {
			    "label": "RequiredInFormula"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigColumnOrder() : FormlyFieldConfig {
			return {
			  "key": "ColumnOrder",
			  "name": "ColumnOrder",
			  "templateOptions": {
			    "type": "number",
			    "label": "ColumnOrder"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSectionOrder() : FormlyFieldConfig {
			return {
			  "key": "SectionOrder",
			  "name": "SectionOrder",
			  "templateOptions": {
			    "type": "number",
			    "label": "SectionOrder"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSectionName() : FormlyFieldConfig {
			return {
			  "key": "SectionName",
			  "name": "SectionName",
			  "templateOptions": {
			    "label": "SectionName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessColumnDataDto.FormlyConfigReadinessColumnDataId,
				ReadinessColumnDataDto.FormlyConfigColumnName,
				ReadinessColumnDataDto.FormlyConfigDisplayName,
				ReadinessColumnDataDto.FormlyConfigColumnType,
				ReadinessColumnDataDto.FormlyConfigIsVisible,
				ReadinessColumnDataDto.FormlyConfigIsRequired,
				ReadinessColumnDataDto.FormlyConfigRequiredInFormula,
				ReadinessColumnDataDto.FormlyConfigColumnOrder,
				ReadinessColumnDataDto.FormlyConfigSectionOrder,
				ReadinessColumnDataDto.FormlyConfigSectionName,
				ReadinessColumnDataDto.FormlyConfigProjectId,
				ReadinessColumnDataDto.FormlyConfigValue
			];
		};
	}

	export class ReadinessData {
		ProPakProjectId: number;
		ArchiveTaskId: number;
		ProjectId: number;
		ProjectPhaseId: number;
		ImportStart: Date;
		ImportEnd: Date;
		Successful: boolean;
		ImportFileLocation: string;
		ProjectTaskId: number;
		TaskNumber: string;
		TaskDescription: string;
		Scope: string;
		PriorityId: number;
		Owner: string;
		Discipline: string;
		Contractor: string;
		Active: boolean;
		TARApprovalId: number;
		HeightAccessId: number;
		Crane: boolean;
		HotWork: boolean;
		IsolationPlanId: number;
		WorkPackRequiredId: number;
		RevId: number;
		MaterialStatusId: number;
		LongLead: boolean;
		FabricationId: number;
		StagedOnSite: number;
		MOCRequired: boolean;
		MOCNumber: string;
		MOCStatusId: number;
		Comments: string;
		ApprovedProjTAR: number;
		TRStatus: number;
		WPStatus: number;
		Materials: number;
		MaterialMOC: number;
		Status: string;
		ShutInRequired: boolean;
		Number: number;
		ActualRowNumber: number;
		IsArchived: boolean;
		ImageBlobUrl: string;
		AttachmentsJson: string;
		PIDAttachmentURL: string;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigArchiveTaskId() : FormlyFieldConfig {
			return {
			  "key": "ArchiveTaskId",
			  "name": "ArchiveTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ArchiveTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectPhaseId() : FormlyFieldConfig {
			return {
			  "key": "ProjectPhaseId",
			  "name": "ProjectPhaseId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectPhaseId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImportStart() : FormlyFieldConfig {
			return {
			  "key": "ImportStart",
			  "name": "ImportStart",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ImportStart"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImportEnd() : FormlyFieldConfig {
			return {
			  "key": "ImportEnd",
			  "name": "ImportEnd",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ImportEnd"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSuccessful() : FormlyFieldConfig {
			return {
			  "key": "Successful",
			  "name": "Successful",
			  "templateOptions": {
			    "label": "Successful"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigImportFileLocation() : FormlyFieldConfig {
			return {
			  "key": "ImportFileLocation",
			  "name": "ImportFileLocation",
			  "templateOptions": {
			    "label": "ImportFileLocation"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectTaskId() : FormlyFieldConfig {
			return {
			  "key": "ProjectTaskId",
			  "name": "ProjectTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskNumber() : FormlyFieldConfig {
			return {
			  "key": "TaskNumber",
			  "name": "TaskNumber",
			  "templateOptions": {
			    "label": "TaskNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskDescription() : FormlyFieldConfig {
			return {
			  "key": "TaskDescription",
			  "name": "TaskDescription",
			  "templateOptions": {
			    "label": "TaskDescription"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigScope() : FormlyFieldConfig {
			return {
			  "key": "Scope",
			  "name": "Scope",
			  "templateOptions": {
			    "label": "Scope"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityId() : FormlyFieldConfig {
			return {
			  "key": "PriorityId",
			  "name": "PriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOwner() : FormlyFieldConfig {
			return {
			  "key": "Owner",
			  "name": "Owner",
			  "templateOptions": {
			    "label": "Owner"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDiscipline() : FormlyFieldConfig {
			return {
			  "key": "Discipline",
			  "name": "Discipline",
			  "templateOptions": {
			    "label": "Discipline"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigContractor() : FormlyFieldConfig {
			return {
			  "key": "Contractor",
			  "name": "Contractor",
			  "templateOptions": {
			    "label": "Contractor"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigTARApprovalId() : FormlyFieldConfig {
			return {
			  "key": "TARApprovalId",
			  "name": "TARApprovalId",
			  "templateOptions": {
			    "type": "number",
			    "label": "TARApprovalId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHeightAccessId() : FormlyFieldConfig {
			return {
			  "key": "HeightAccessId",
			  "name": "HeightAccessId",
			  "templateOptions": {
			    "type": "number",
			    "label": "HeightAccessId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCrane() : FormlyFieldConfig {
			return {
			  "key": "Crane",
			  "name": "Crane",
			  "templateOptions": {
			    "label": "Crane"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigHotWork() : FormlyFieldConfig {
			return {
			  "key": "HotWork",
			  "name": "HotWork",
			  "templateOptions": {
			    "label": "HotWork"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIsolationPlanId() : FormlyFieldConfig {
			return {
			  "key": "IsolationPlanId",
			  "name": "IsolationPlanId",
			  "templateOptions": {
			    "type": "number",
			    "label": "IsolationPlanId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWorkPackRequiredId() : FormlyFieldConfig {
			return {
			  "key": "WorkPackRequiredId",
			  "name": "WorkPackRequiredId",
			  "templateOptions": {
			    "type": "number",
			    "label": "WorkPackRequiredId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRevId() : FormlyFieldConfig {
			return {
			  "key": "RevId",
			  "name": "RevId",
			  "templateOptions": {
			    "type": "number",
			    "label": "RevId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialStatusId() : FormlyFieldConfig {
			return {
			  "key": "MaterialStatusId",
			  "name": "MaterialStatusId",
			  "templateOptions": {
			    "type": "number",
			    "label": "MaterialStatusId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLongLead() : FormlyFieldConfig {
			return {
			  "key": "LongLead",
			  "name": "LongLead",
			  "templateOptions": {
			    "label": "LongLead"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigFabricationId() : FormlyFieldConfig {
			return {
			  "key": "FabricationId",
			  "name": "FabricationId",
			  "templateOptions": {
			    "type": "number",
			    "label": "FabricationId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStagedOnSite() : FormlyFieldConfig {
			return {
			  "key": "StagedOnSite",
			  "name": "StagedOnSite",
			  "templateOptions": {
			    "type": "number",
			    "label": "StagedOnSite"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCRequired() : FormlyFieldConfig {
			return {
			  "key": "MOCRequired",
			  "name": "MOCRequired",
			  "templateOptions": {
			    "label": "MOCRequired"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigMOCNumber() : FormlyFieldConfig {
			return {
			  "key": "MOCNumber",
			  "name": "MOCNumber",
			  "templateOptions": {
			    "label": "MOCNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCStatusId() : FormlyFieldConfig {
			return {
			  "key": "MOCStatusId",
			  "name": "MOCStatusId",
			  "templateOptions": {
			    "type": "number",
			    "label": "MOCStatusId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigComments() : FormlyFieldConfig {
			return {
			  "key": "Comments",
			  "name": "Comments",
			  "templateOptions": {
			    "label": "Comments"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigApprovedProjTAR() : FormlyFieldConfig {
			return {
			  "key": "ApprovedProjTAR",
			  "name": "ApprovedProjTAR",
			  "templateOptions": {
			    "type": "number",
			    "label": "ApprovedProjTAR"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTRStatus() : FormlyFieldConfig {
			return {
			  "key": "TRStatus",
			  "name": "TRStatus",
			  "templateOptions": {
			    "type": "number",
			    "label": "TRStatus"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWPStatus() : FormlyFieldConfig {
			return {
			  "key": "WPStatus",
			  "name": "WPStatus",
			  "templateOptions": {
			    "type": "number",
			    "label": "WPStatus"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterials() : FormlyFieldConfig {
			return {
			  "key": "Materials",
			  "name": "Materials",
			  "templateOptions": {
			    "type": "number",
			    "label": "Materials"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialMOC() : FormlyFieldConfig {
			return {
			  "key": "MaterialMOC",
			  "name": "MaterialMOC",
			  "templateOptions": {
			    "type": "number",
			    "label": "MaterialMOC"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStatus() : FormlyFieldConfig {
			return {
			  "key": "Status",
			  "name": "Status",
			  "templateOptions": {
			    "label": "Status"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigShutInRequired() : FormlyFieldConfig {
			return {
			  "key": "ShutInRequired",
			  "name": "ShutInRequired",
			  "templateOptions": {
			    "label": "ShutInRequired"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigNumber() : FormlyFieldConfig {
			return {
			  "key": "Number",
			  "name": "Number",
			  "templateOptions": {
			    "type": "number",
			    "label": "Number"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActualRowNumber() : FormlyFieldConfig {
			return {
			  "key": "ActualRowNumber",
			  "name": "ActualRowNumber",
			  "templateOptions": {
			    "type": "number",
			    "label": "ActualRowNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsArchived() : FormlyFieldConfig {
			return {
			  "key": "IsArchived",
			  "name": "IsArchived",
			  "templateOptions": {
			    "label": "IsArchived"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigImageBlobUrl() : FormlyFieldConfig {
			return {
			  "key": "ImageBlobUrl",
			  "name": "ImageBlobUrl",
			  "templateOptions": {
			    "label": "ImageBlobUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAttachmentsJson() : FormlyFieldConfig {
			return {
			  "key": "AttachmentsJson",
			  "name": "AttachmentsJson",
			  "templateOptions": {
			    "label": "AttachmentsJson"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPIDAttachmentURL() : FormlyFieldConfig {
			return {
			  "key": "PIDAttachmentURL",
			  "name": "PIDAttachmentURL",
			  "templateOptions": {
			    "label": "PIDAttachmentURL"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessData.FormlyConfigProPakProjectId,
				ReadinessData.FormlyConfigArchiveTaskId,
				ReadinessData.FormlyConfigProjectId,
				ReadinessData.FormlyConfigProjectPhaseId,
				ReadinessData.FormlyConfigImportStart,
				ReadinessData.FormlyConfigImportEnd,
				ReadinessData.FormlyConfigSuccessful,
				ReadinessData.FormlyConfigImportFileLocation,
				ReadinessData.FormlyConfigProjectTaskId,
				ReadinessData.FormlyConfigTaskNumber,
				ReadinessData.FormlyConfigTaskDescription,
				ReadinessData.FormlyConfigScope,
				ReadinessData.FormlyConfigPriorityId,
				ReadinessData.FormlyConfigOwner,
				ReadinessData.FormlyConfigDiscipline,
				ReadinessData.FormlyConfigContractor,
				ReadinessData.FormlyConfigActive,
				ReadinessData.FormlyConfigTARApprovalId,
				ReadinessData.FormlyConfigHeightAccessId,
				ReadinessData.FormlyConfigCrane,
				ReadinessData.FormlyConfigHotWork,
				ReadinessData.FormlyConfigIsolationPlanId,
				ReadinessData.FormlyConfigWorkPackRequiredId,
				ReadinessData.FormlyConfigRevId,
				ReadinessData.FormlyConfigMaterialStatusId,
				ReadinessData.FormlyConfigLongLead,
				ReadinessData.FormlyConfigFabricationId,
				ReadinessData.FormlyConfigStagedOnSite,
				ReadinessData.FormlyConfigMOCRequired,
				ReadinessData.FormlyConfigMOCNumber,
				ReadinessData.FormlyConfigMOCStatusId,
				ReadinessData.FormlyConfigComments,
				ReadinessData.FormlyConfigApprovedProjTAR,
				ReadinessData.FormlyConfigTRStatus,
				ReadinessData.FormlyConfigWPStatus,
				ReadinessData.FormlyConfigMaterials,
				ReadinessData.FormlyConfigMaterialMOC,
				ReadinessData.FormlyConfigStatus,
				ReadinessData.FormlyConfigShutInRequired,
				ReadinessData.FormlyConfigNumber,
				ReadinessData.FormlyConfigActualRowNumber,
				ReadinessData.FormlyConfigIsArchived,
				ReadinessData.FormlyConfigImageBlobUrl,
				ReadinessData.FormlyConfigAttachmentsJson,
				ReadinessData.FormlyConfigPIDAttachmentURL
			];
		};
	}

	export class ReadinessDto {
		TaskNumber: string;
		TaskDescription: string;
		Scope: string;
		PriorityName: string;
		TaskOwner: string;
		DisciplineName: string;
		Contractor: string;
		TARApprovalName: string;
		HeightAccessName: string;
		Crane: string;
		HotWorkName: string;
		IsolationPlanName: string;
		WorkPackProcedureRequiredName: string;
		RevName: string;
		MaterialStatusName: string;
		LongLead: string;
		FabricationName: string;
		StagedOnSite: string;
		MOCRequired: string;
		MOCNumber: string;
		MOCStatusName: string;
		Comments: string;

		static get FormlyConfigTaskNumber() : FormlyFieldConfig {
			return {
			  "key": "TaskNumber",
			  "name": "TaskNumber",
			  "templateOptions": {
			    "label": "TaskNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskDescription() : FormlyFieldConfig {
			return {
			  "key": "TaskDescription",
			  "name": "TaskDescription",
			  "templateOptions": {
			    "label": "TaskDescription"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigScope() : FormlyFieldConfig {
			return {
			  "key": "Scope",
			  "name": "Scope",
			  "templateOptions": {
			    "label": "Scope"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityName() : FormlyFieldConfig {
			return {
			  "key": "PriorityName",
			  "name": "PriorityName",
			  "templateOptions": {
			    "label": "PriorityName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskOwner() : FormlyFieldConfig {
			return {
			  "key": "TaskOwner",
			  "name": "TaskOwner",
			  "templateOptions": {
			    "label": "TaskOwner"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisciplineName() : FormlyFieldConfig {
			return {
			  "key": "DisciplineName",
			  "name": "DisciplineName",
			  "templateOptions": {
			    "label": "DisciplineName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigContractor() : FormlyFieldConfig {
			return {
			  "key": "Contractor",
			  "name": "Contractor",
			  "templateOptions": {
			    "label": "Contractor"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTARApprovalName() : FormlyFieldConfig {
			return {
			  "key": "TARApprovalName",
			  "name": "TARApprovalName",
			  "templateOptions": {
			    "label": "TARApprovalName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHeightAccessName() : FormlyFieldConfig {
			return {
			  "key": "HeightAccessName",
			  "name": "HeightAccessName",
			  "templateOptions": {
			    "label": "HeightAccessName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCrane() : FormlyFieldConfig {
			return {
			  "key": "Crane",
			  "name": "Crane",
			  "templateOptions": {
			    "label": "Crane"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigHotWorkName() : FormlyFieldConfig {
			return {
			  "key": "HotWorkName",
			  "name": "HotWorkName",
			  "templateOptions": {
			    "label": "HotWorkName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsolationPlanName() : FormlyFieldConfig {
			return {
			  "key": "IsolationPlanName",
			  "name": "IsolationPlanName",
			  "templateOptions": {
			    "label": "IsolationPlanName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWorkPackProcedureRequiredName() : FormlyFieldConfig {
			return {
			  "key": "WorkPackProcedureRequiredName",
			  "name": "WorkPackProcedureRequiredName",
			  "templateOptions": {
			    "label": "WorkPackProcedureRequiredName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRevName() : FormlyFieldConfig {
			return {
			  "key": "RevName",
			  "name": "RevName",
			  "templateOptions": {
			    "label": "RevName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMaterialStatusName() : FormlyFieldConfig {
			return {
			  "key": "MaterialStatusName",
			  "name": "MaterialStatusName",
			  "templateOptions": {
			    "label": "MaterialStatusName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLongLead() : FormlyFieldConfig {
			return {
			  "key": "LongLead",
			  "name": "LongLead",
			  "templateOptions": {
			    "label": "LongLead"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFabricationName() : FormlyFieldConfig {
			return {
			  "key": "FabricationName",
			  "name": "FabricationName",
			  "templateOptions": {
			    "label": "FabricationName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStagedOnSite() : FormlyFieldConfig {
			return {
			  "key": "StagedOnSite",
			  "name": "StagedOnSite",
			  "templateOptions": {
			    "label": "StagedOnSite"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCRequired() : FormlyFieldConfig {
			return {
			  "key": "MOCRequired",
			  "name": "MOCRequired",
			  "templateOptions": {
			    "label": "MOCRequired"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCNumber() : FormlyFieldConfig {
			return {
			  "key": "MOCNumber",
			  "name": "MOCNumber",
			  "templateOptions": {
			    "label": "MOCNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMOCStatusName() : FormlyFieldConfig {
			return {
			  "key": "MOCStatusName",
			  "name": "MOCStatusName",
			  "templateOptions": {
			    "label": "MOCStatusName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigComments() : FormlyFieldConfig {
			return {
			  "key": "Comments",
			  "name": "Comments",
			  "templateOptions": {
			    "label": "Comments"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessDto.FormlyConfigTaskNumber,
				ReadinessDto.FormlyConfigTaskDescription,
				ReadinessDto.FormlyConfigScope,
				ReadinessDto.FormlyConfigPriorityName,
				ReadinessDto.FormlyConfigTaskOwner,
				ReadinessDto.FormlyConfigDisciplineName,
				ReadinessDto.FormlyConfigContractor,
				ReadinessDto.FormlyConfigTARApprovalName,
				ReadinessDto.FormlyConfigHeightAccessName,
				ReadinessDto.FormlyConfigCrane,
				ReadinessDto.FormlyConfigHotWorkName,
				ReadinessDto.FormlyConfigIsolationPlanName,
				ReadinessDto.FormlyConfigWorkPackProcedureRequiredName,
				ReadinessDto.FormlyConfigRevName,
				ReadinessDto.FormlyConfigMaterialStatusName,
				ReadinessDto.FormlyConfigLongLead,
				ReadinessDto.FormlyConfigFabricationName,
				ReadinessDto.FormlyConfigStagedOnSite,
				ReadinessDto.FormlyConfigMOCRequired,
				ReadinessDto.FormlyConfigMOCNumber,
				ReadinessDto.FormlyConfigMOCStatusName,
				ReadinessDto.FormlyConfigComments
			];
		};
	}

	export class ReadinessExportTaskRef {
		ProjectTaskId: number;
		ArchiveTaskId: number;
		TaskNumber: string;
		IsArchived: boolean;

		static get FormlyConfigProjectTaskId() : FormlyFieldConfig {
			return {
			  "key": "ProjectTaskId",
			  "name": "ProjectTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigArchiveTaskId() : FormlyFieldConfig {
			return {
			  "key": "ArchiveTaskId",
			  "name": "ArchiveTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ArchiveTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskNumber() : FormlyFieldConfig {
			return {
			  "key": "TaskNumber",
			  "name": "TaskNumber",
			  "templateOptions": {
			    "label": "TaskNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsArchived() : FormlyFieldConfig {
			return {
			  "key": "IsArchived",
			  "name": "IsArchived",
			  "templateOptions": {
			    "label": "IsArchived"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessExportTaskRef.FormlyConfigProjectTaskId,
				ReadinessExportTaskRef.FormlyConfigArchiveTaskId,
				ReadinessExportTaskRef.FormlyConfigTaskNumber,
				ReadinessExportTaskRef.FormlyConfigIsArchived
			];
		};
	}

	export class ReadinessSummaryDto {
		Project: ProjectDto = new ProjectDto();
		ReadinessFileLocation: string;
		Priorities: ReadinessTaskPriorityStatusDto[] = [];
		ProPakProjectUrl: string;
		PassThroughAuthKey: string;
		ProPakPassThroughFullUrl: string;
		PercentComplete: number;

		static get FormlyConfigProject() : FormlyFieldConfig {
			return {
			  "key": "Project",
			  "name": "Project",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "Project"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigReadinessFileLocation() : FormlyFieldConfig {
			return {
			  "key": "ReadinessFileLocation",
			  "name": "ReadinessFileLocation",
			  "templateOptions": {
			    "label": "ReadinessFileLocation"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorities() : FormlyFieldConfig {
			return {
			  "key": "Priorities",
			  "name": "Priorities",
			  "templateOptions": {
			    "label": "Priorities",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigProPakProjectUrl() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectUrl",
			  "name": "ProPakProjectUrl",
			  "templateOptions": {
			    "label": "ProPakProjectUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPassThroughAuthKey() : FormlyFieldConfig {
			return {
			  "key": "PassThroughAuthKey",
			  "name": "PassThroughAuthKey",
			  "templateOptions": {
			    "label": "PassThroughAuthKey"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProPakPassThroughFullUrl() : FormlyFieldConfig {
			return {
			  "key": "ProPakPassThroughFullUrl",
			  "name": "ProPakPassThroughFullUrl",
			  "templateOptions": {
			    "label": "ProPakPassThroughFullUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessSummaryDto.FormlyConfigProject,
				ReadinessSummaryDto.FormlyConfigReadinessFileLocation,
				ReadinessSummaryDto.FormlyConfigPriorities,
				ReadinessSummaryDto.FormlyConfigProPakProjectUrl,
				ReadinessSummaryDto.FormlyConfigPassThroughAuthKey,
				ReadinessSummaryDto.FormlyConfigProPakPassThroughFullUrl,
				ReadinessSummaryDto.FormlyConfigPercentComplete
			];
		};
	}

	export class ReadinessTaskAttachmentCountDto {
		ProjectTaskId: number;
		Count: number;

		static get FormlyConfigProjectTaskId() : FormlyFieldConfig {
			return {
			  "key": "ProjectTaskId",
			  "name": "ProjectTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCount() : FormlyFieldConfig {
			return {
			  "key": "Count",
			  "name": "Count",
			  "templateOptions": {
			    "type": "number",
			    "label": "Count"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessTaskAttachmentCountDto.FormlyConfigProjectTaskId,
				ReadinessTaskAttachmentCountDto.FormlyConfigCount
			];
		};
	}

	export class ReadinessTaskAttachmentDto {
		ReadinessTaskAttachmentId: number;
		FileName: string;
		BlobUrl: string;
		FileType: string;
		Source: string;
		IsTaskImage: boolean;

		static get FormlyConfigReadinessTaskAttachmentId() : FormlyFieldConfig {
			return {
			  "key": "ReadinessTaskAttachmentId",
			  "name": "ReadinessTaskAttachmentId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ReadinessTaskAttachmentId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileName() : FormlyFieldConfig {
			return {
			  "key": "FileName",
			  "name": "FileName",
			  "templateOptions": {
			    "label": "FileName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBlobUrl() : FormlyFieldConfig {
			return {
			  "key": "BlobUrl",
			  "name": "BlobUrl",
			  "templateOptions": {
			    "label": "BlobUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileType() : FormlyFieldConfig {
			return {
			  "key": "FileType",
			  "name": "FileType",
			  "templateOptions": {
			    "label": "FileType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSource() : FormlyFieldConfig {
			return {
			  "key": "Source",
			  "name": "Source",
			  "templateOptions": {
			    "label": "Source"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsTaskImage() : FormlyFieldConfig {
			return {
			  "key": "IsTaskImage",
			  "name": "IsTaskImage",
			  "templateOptions": {
			    "label": "IsTaskImage"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessTaskAttachmentDto.FormlyConfigReadinessTaskAttachmentId,
				ReadinessTaskAttachmentDto.FormlyConfigFileName,
				ReadinessTaskAttachmentDto.FormlyConfigBlobUrl,
				ReadinessTaskAttachmentDto.FormlyConfigFileType,
				ReadinessTaskAttachmentDto.FormlyConfigSource,
				ReadinessTaskAttachmentDto.FormlyConfigIsTaskImage
			];
		};
	}

	export class ReadinessTaskAttachmentItemDto {
		ReadinessTaskAttachmentId: number;
		FileName: string;
		BlobUrl: string;
		FileType: string;
		Source: string;
		IsTaskImage: boolean;

		static get FormlyConfigReadinessTaskAttachmentId() : FormlyFieldConfig {
			return {
			  "key": "ReadinessTaskAttachmentId",
			  "name": "ReadinessTaskAttachmentId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ReadinessTaskAttachmentId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileName() : FormlyFieldConfig {
			return {
			  "key": "FileName",
			  "name": "FileName",
			  "templateOptions": {
			    "label": "FileName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBlobUrl() : FormlyFieldConfig {
			return {
			  "key": "BlobUrl",
			  "name": "BlobUrl",
			  "templateOptions": {
			    "label": "BlobUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileType() : FormlyFieldConfig {
			return {
			  "key": "FileType",
			  "name": "FileType",
			  "templateOptions": {
			    "label": "FileType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSource() : FormlyFieldConfig {
			return {
			  "key": "Source",
			  "name": "Source",
			  "templateOptions": {
			    "label": "Source"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsTaskImage() : FormlyFieldConfig {
			return {
			  "key": "IsTaskImage",
			  "name": "IsTaskImage",
			  "templateOptions": {
			    "label": "IsTaskImage"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessTaskAttachmentItemDto.FormlyConfigReadinessTaskAttachmentId,
				ReadinessTaskAttachmentItemDto.FormlyConfigFileName,
				ReadinessTaskAttachmentItemDto.FormlyConfigBlobUrl,
				ReadinessTaskAttachmentItemDto.FormlyConfigFileType,
				ReadinessTaskAttachmentItemDto.FormlyConfigSource,
				ReadinessTaskAttachmentItemDto.FormlyConfigIsTaskImage
			];
		};
	}

	export class ReadinessTaskPriorityStatusDto {
		PriorityId: number;
		PriorityName: string;
		Categories: ReadinessCategoryStatusDto[] = [];
		TaskCountTotal: number;
		TaskCountComplete: number;
		PercentComplete: number;

		static get FormlyConfigPriorityId() : FormlyFieldConfig {
			return {
			  "key": "PriorityId",
			  "name": "PriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityName() : FormlyFieldConfig {
			return {
			  "key": "PriorityName",
			  "name": "PriorityName",
			  "templateOptions": {
			    "label": "PriorityName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCategories() : FormlyFieldConfig {
			return {
			  "key": "Categories",
			  "name": "Categories",
			  "templateOptions": {
			    "label": "Categories",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountComplete() : FormlyFieldConfig {
			return {
			  "key": "TaskCountComplete",
			  "name": "TaskCountComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessTaskPriorityStatusDto.FormlyConfigPriorityId,
				ReadinessTaskPriorityStatusDto.FormlyConfigPriorityName,
				ReadinessTaskPriorityStatusDto.FormlyConfigCategories,
				ReadinessTaskPriorityStatusDto.FormlyConfigTaskCountTotal,
				ReadinessTaskPriorityStatusDto.FormlyConfigTaskCountComplete,
				ReadinessTaskPriorityStatusDto.FormlyConfigPercentComplete
			];
		};
	}

	export class ReadinessTrafficLightRuleDto {
		ReadinessTrafficLightRuleId: number;
		ProjectId: number;
		SectionName: string;
		Color: string;
		Operator: string;
		ThresholdValue: number;
		RuleOrder: number;

		static get FormlyConfigReadinessTrafficLightRuleId() : FormlyFieldConfig {
			return {
			  "key": "ReadinessTrafficLightRuleId",
			  "name": "ReadinessTrafficLightRuleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ReadinessTrafficLightRuleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSectionName() : FormlyFieldConfig {
			return {
			  "key": "SectionName",
			  "name": "SectionName",
			  "templateOptions": {
			    "label": "SectionName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigColor() : FormlyFieldConfig {
			return {
			  "key": "Color",
			  "name": "Color",
			  "templateOptions": {
			    "label": "Color"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOperator() : FormlyFieldConfig {
			return {
			  "key": "Operator",
			  "name": "Operator",
			  "templateOptions": {
			    "label": "Operator"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigThresholdValue() : FormlyFieldConfig {
			return {
			  "key": "ThresholdValue",
			  "name": "ThresholdValue",
			  "templateOptions": {
			    "type": "number",
			    "label": "ThresholdValue"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRuleOrder() : FormlyFieldConfig {
			return {
			  "key": "RuleOrder",
			  "name": "RuleOrder",
			  "templateOptions": {
			    "type": "number",
			    "label": "RuleOrder"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessTrafficLightRuleDto.FormlyConfigReadinessTrafficLightRuleId,
				ReadinessTrafficLightRuleDto.FormlyConfigProjectId,
				ReadinessTrafficLightRuleDto.FormlyConfigSectionName,
				ReadinessTrafficLightRuleDto.FormlyConfigColor,
				ReadinessTrafficLightRuleDto.FormlyConfigOperator,
				ReadinessTrafficLightRuleDto.FormlyConfigThresholdValue,
				ReadinessTrafficLightRuleDto.FormlyConfigRuleOrder
			];
		};
	}

	export class RevDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				RevDto.FormlyConfigId,
				RevDto.FormlyConfigDescription,
				RevDto.FormlyConfigValue,
				RevDto.FormlyConfigWeight,
				RevDto.FormlyConfigIsActive,
				RevDto.FormlyConfigModifiedByUserId,
				RevDto.FormlyConfigModifiedDate
			];
		};
	}

	export class RoleDto {
		Id: number;
		Name: string;
		Checkpoints: SecurityCheckpointDto[] = [];

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCheckpoints() : FormlyFieldConfig {
			return {
			  "key": "Checkpoints",
			  "name": "Checkpoints",
			  "templateOptions": {
			    "label": "Checkpoints",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				RoleDto.FormlyConfigId,
				RoleDto.FormlyConfigName,
				RoleDto.FormlyConfigCheckpoints
			];
		};
	}

	export class RoleSearchRow {
		Id: number;
		Name: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				RoleSearchRow.FormlyConfigId,
				RoleSearchRow.FormlyConfigName
			];
		};
	}

	export class SearchGridFormatTestSearchRow {
		Id: number;
		Name: string;
		Image: Blob;
		Checkbox: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImage() : FormlyFieldConfig {
			return {
			  "key": "Image",
			  "name": "Image",
			  "templateOptions": {
			    "label": "Image",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCheckbox() : FormlyFieldConfig {
			return {
			  "key": "Checkbox",
			  "name": "Checkbox",
			  "templateOptions": {
			    "label": "Checkbox"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SearchGridFormatTestSearchRow.FormlyConfigId,
				SearchGridFormatTestSearchRow.FormlyConfigName,
				SearchGridFormatTestSearchRow.FormlyConfigImage,
				SearchGridFormatTestSearchRow.FormlyConfigCheckbox
			];
		};
	}

	export class SearchTestSearchRow {
		Id: number;
		UserId: number;
		Name: string;
		BigInt: number;
		Date: Date;
		DateTime2: Date;
		DateTimeOffset: Date;
		Guid: string;
		Active: boolean;
		AddDate: Date;
		AddUser: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserId() : FormlyFieldConfig {
			return {
			  "key": "UserId",
			  "name": "UserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "UserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigBigInt() : FormlyFieldConfig {
			return {
			  "key": "BigInt",
			  "name": "BigInt",
			  "templateOptions": {
			    "type": "number",
			    "label": "BigInt"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDate() : FormlyFieldConfig {
			return {
			  "key": "Date",
			  "name": "Date",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDateTime2() : FormlyFieldConfig {
			return {
			  "key": "DateTime2",
			  "name": "DateTime2",
			  "templateOptions": {
			    "type": "Date",
			    "label": "DateTime2"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDateTimeOffset() : FormlyFieldConfig {
			return {
			  "key": "DateTimeOffset",
			  "name": "DateTimeOffset",
			  "templateOptions": {
			    "type": "Date",
			    "label": "DateTimeOffset"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigGuid() : FormlyFieldConfig {
			return {
			  "key": "Guid",
			  "name": "Guid",
			  "templateOptions": {
			    "label": "Guid"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigAddDate() : FormlyFieldConfig {
			return {
			  "key": "AddDate",
			  "name": "AddDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "AddDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAddUser() : FormlyFieldConfig {
			return {
			  "key": "AddUser",
			  "name": "AddUser",
			  "templateOptions": {
			    "label": "AddUser"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SearchTestSearchRow.FormlyConfigId,
				SearchTestSearchRow.FormlyConfigUserId,
				SearchTestSearchRow.FormlyConfigName,
				SearchTestSearchRow.FormlyConfigBigInt,
				SearchTestSearchRow.FormlyConfigDate,
				SearchTestSearchRow.FormlyConfigDateTime2,
				SearchTestSearchRow.FormlyConfigDateTimeOffset,
				SearchTestSearchRow.FormlyConfigGuid,
				SearchTestSearchRow.FormlyConfigActive,
				SearchTestSearchRow.FormlyConfigAddDate,
				SearchTestSearchRow.FormlyConfigAddUser
			];
		};
	}

	export class SecurityCheckpointDto {
		Id: number;
		CommandName: string;
		Description: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCommandName() : FormlyFieldConfig {
			return {
			  "key": "CommandName",
			  "name": "CommandName",
			  "templateOptions": {
			    "label": "CommandName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SecurityCheckpointDto.FormlyConfigId,
				SecurityCheckpointDto.FormlyConfigCommandName,
				SecurityCheckpointDto.FormlyConfigDescription
			];
		};
	}

	export class SiteSenseProjectDto {
		Id: number;
		Name: string;
		Description: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SiteSenseProjectDto.FormlyConfigId,
				SiteSenseProjectDto.FormlyConfigName,
				SiteSenseProjectDto.FormlyConfigDescription
			];
		};
	}

	export class StagedOnSiteDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				StagedOnSiteDto.FormlyConfigId,
				StagedOnSiteDto.FormlyConfigDescription,
				StagedOnSiteDto.FormlyConfigValue,
				StagedOnSiteDto.FormlyConfigWeight,
				StagedOnSiteDto.FormlyConfigIsActive,
				StagedOnSiteDto.FormlyConfigModifiedByUserId,
				StagedOnSiteDto.FormlyConfigModifiedDate
			];
		};
	}

	export class StageDto {
		StageId: number;
		StageName: string;
		TaskCountTotal: number;
		TotalWeight: number;
		CompletedWeight: number;
		PercentComplete: number;
		DurationComplete: number;

		static get FormlyConfigStageId() : FormlyFieldConfig {
			return {
			  "key": "StageId",
			  "name": "StageId",
			  "templateOptions": {
			    "type": "number",
			    "label": "StageId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStageName() : FormlyFieldConfig {
			return {
			  "key": "StageName",
			  "name": "StageName",
			  "templateOptions": {
			    "label": "StageName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalWeight() : FormlyFieldConfig {
			return {
			  "key": "TotalWeight",
			  "name": "TotalWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedWeight() : FormlyFieldConfig {
			return {
			  "key": "CompletedWeight",
			  "name": "CompletedWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompletedWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDurationComplete() : FormlyFieldConfig {
			return {
			  "key": "DurationComplete",
			  "name": "DurationComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "DurationComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				StageDto.FormlyConfigStageId,
				StageDto.FormlyConfigStageName,
				StageDto.FormlyConfigTaskCountTotal,
				StageDto.FormlyConfigTotalWeight,
				StageDto.FormlyConfigCompletedWeight,
				StageDto.FormlyConfigPercentComplete,
				StageDto.FormlyConfigDurationComplete
			];
		};
	}

	export class StageStatusDto {
		Project: ProjectDto = new ProjectDto();
		TotalWeight: number;
		CompletedWeight: number;
		PercentComplete: number;
		SummaryStages: SummaryStageDto[] = [];

		static get FormlyConfigProject() : FormlyFieldConfig {
			return {
			  "key": "Project",
			  "name": "Project",
			  "templateOptions": {
			    "type": "ProjectDto = new ProjectDto()",
			    "label": "Project"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalWeight() : FormlyFieldConfig {
			return {
			  "key": "TotalWeight",
			  "name": "TotalWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedWeight() : FormlyFieldConfig {
			return {
			  "key": "CompletedWeight",
			  "name": "CompletedWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompletedWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSummaryStages() : FormlyFieldConfig {
			return {
			  "key": "SummaryStages",
			  "name": "SummaryStages",
			  "templateOptions": {
			    "label": "SummaryStages",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				StageStatusDto.FormlyConfigProject,
				StageStatusDto.FormlyConfigTotalWeight,
				StageStatusDto.FormlyConfigCompletedWeight,
				StageStatusDto.FormlyConfigPercentComplete,
				StageStatusDto.FormlyConfigSummaryStages
			];
		};
	}

	export class SummaryPriorityDto {
		PriorityId: number;
		PriorityName: string;
		TaskCountTotal: number;
		TaskCountCompleted: number;
		TaskCountIncomplete: number;

		static get FormlyConfigPriorityId() : FormlyFieldConfig {
			return {
			  "key": "PriorityId",
			  "name": "PriorityId",
			  "templateOptions": {
			    "type": "number",
			    "label": "PriorityId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorityName() : FormlyFieldConfig {
			return {
			  "key": "PriorityName",
			  "name": "PriorityName",
			  "templateOptions": {
			    "label": "PriorityName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountCompleted() : FormlyFieldConfig {
			return {
			  "key": "TaskCountCompleted",
			  "name": "TaskCountCompleted",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountCompleted"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountIncomplete() : FormlyFieldConfig {
			return {
			  "key": "TaskCountIncomplete",
			  "name": "TaskCountIncomplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountIncomplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SummaryPriorityDto.FormlyConfigPriorityId,
				SummaryPriorityDto.FormlyConfigPriorityName,
				SummaryPriorityDto.FormlyConfigTaskCountTotal,
				SummaryPriorityDto.FormlyConfigTaskCountCompleted,
				SummaryPriorityDto.FormlyConfigTaskCountIncomplete
			];
		};
	}

	export class SummaryStageDto {
		SummaryStageId: number;
		StageName: string;
		TaskCountTotal: number;
		TotalWeight: number;
		CompletedWeight: number;
		DurationPercentComplete: number;
		PercentComplete: number;
		Stages: StageDto[] = [];

		static get FormlyConfigSummaryStageId() : FormlyFieldConfig {
			return {
			  "key": "SummaryStageId",
			  "name": "SummaryStageId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SummaryStageId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStageName() : FormlyFieldConfig {
			return {
			  "key": "StageName",
			  "name": "StageName",
			  "templateOptions": {
			    "label": "StageName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskCountTotal() : FormlyFieldConfig {
			return {
			  "key": "TaskCountTotal",
			  "name": "TaskCountTotal",
			  "templateOptions": {
			    "type": "number",
			    "label": "TaskCountTotal"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalWeight() : FormlyFieldConfig {
			return {
			  "key": "TotalWeight",
			  "name": "TotalWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedWeight() : FormlyFieldConfig {
			return {
			  "key": "CompletedWeight",
			  "name": "CompletedWeight",
			  "templateOptions": {
			    "type": "number",
			    "label": "CompletedWeight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDurationPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "DurationPercentComplete",
			  "name": "DurationPercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "DurationPercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPercentComplete() : FormlyFieldConfig {
			return {
			  "key": "PercentComplete",
			  "name": "PercentComplete",
			  "templateOptions": {
			    "type": "number",
			    "label": "PercentComplete"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStages() : FormlyFieldConfig {
			return {
			  "key": "Stages",
			  "name": "Stages",
			  "templateOptions": {
			    "label": "Stages",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SummaryStageDto.FormlyConfigSummaryStageId,
				SummaryStageDto.FormlyConfigStageName,
				SummaryStageDto.FormlyConfigTaskCountTotal,
				SummaryStageDto.FormlyConfigTotalWeight,
				SummaryStageDto.FormlyConfigCompletedWeight,
				SummaryStageDto.FormlyConfigDurationPercentComplete,
				SummaryStageDto.FormlyConfigPercentComplete,
				SummaryStageDto.FormlyConfigStages
			];
		};
	}

	export class SupportTicketDto {
		SupportTicketId: number;
		Title: string;
		Description: string;
		Type: number;
		ImageUrl: string;
		ImageBase64: string;
		Image: Blob;
		Status: number;
		CreatedBy: string;
		CreatedDate: Date;
		ModifiedBy: string;
		ModifiedDate: Date;
		CompletedBy: string;

		static get FormlyConfigSupportTicketId() : FormlyFieldConfig {
			return {
			  "key": "SupportTicketId",
			  "name": "SupportTicketId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SupportTicketId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTitle() : FormlyFieldConfig {
			return {
			  "key": "Title",
			  "name": "Title",
			  "templateOptions": {
			    "label": "Title"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigType() : FormlyFieldConfig {
			return {
			  "key": "Type",
			  "name": "Type",
			  "templateOptions": {
			    "type": "number",
			    "label": "Type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImageUrl() : FormlyFieldConfig {
			return {
			  "key": "ImageUrl",
			  "name": "ImageUrl",
			  "templateOptions": {
			    "label": "ImageUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImageBase64() : FormlyFieldConfig {
			return {
			  "key": "ImageBase64",
			  "name": "ImageBase64",
			  "templateOptions": {
			    "label": "ImageBase64"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigImage() : FormlyFieldConfig {
			return {
			  "key": "Image",
			  "name": "Image",
			  "templateOptions": {
			    "label": "Image",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigStatus() : FormlyFieldConfig {
			return {
			  "key": "Status",
			  "name": "Status",
			  "templateOptions": {
			    "type": "number",
			    "label": "Status"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreatedBy() : FormlyFieldConfig {
			return {
			  "key": "CreatedBy",
			  "name": "CreatedBy",
			  "templateOptions": {
			    "label": "CreatedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreatedDate() : FormlyFieldConfig {
			return {
			  "key": "CreatedDate",
			  "name": "CreatedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreatedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedBy() : FormlyFieldConfig {
			return {
			  "key": "ModifiedBy",
			  "name": "ModifiedBy",
			  "templateOptions": {
			    "label": "ModifiedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCompletedBy() : FormlyFieldConfig {
			return {
			  "key": "CompletedBy",
			  "name": "CompletedBy",
			  "templateOptions": {
			    "label": "CompletedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SupportTicketDto.FormlyConfigSupportTicketId,
				SupportTicketDto.FormlyConfigTitle,
				SupportTicketDto.FormlyConfigDescription,
				SupportTicketDto.FormlyConfigType,
				SupportTicketDto.FormlyConfigImageUrl,
				SupportTicketDto.FormlyConfigImageBase64,
				SupportTicketDto.FormlyConfigImage,
				SupportTicketDto.FormlyConfigStatus,
				SupportTicketDto.FormlyConfigCreatedBy,
				SupportTicketDto.FormlyConfigCreatedDate,
				SupportTicketDto.FormlyConfigModifiedBy,
				SupportTicketDto.FormlyConfigModifiedDate,
				SupportTicketDto.FormlyConfigCompletedBy
			];
		};
	}

	export class SystemUpdateDto {
		Id: number;
		Title: string;
		Content: string;
		Category: string;
		UpdatedOn: Date;
		Attachments: string;
		AttachmentsJson: string;
		ActiveDays: number;
		IsActive: boolean = true;
		CreatedBy: string;
		CreatedDate: Date;
		ModifiedBy: string;
		ModifiedDate: Date;
		IsForProPak: boolean;
		IsForClientDash: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTitle() : FormlyFieldConfig {
			return {
			  "key": "Title",
			  "name": "Title",
			  "templateOptions": {
			    "label": "Title"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigContent() : FormlyFieldConfig {
			return {
			  "key": "Content",
			  "name": "Content",
			  "templateOptions": {
			    "label": "Content"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCategory() : FormlyFieldConfig {
			return {
			  "key": "Category",
			  "name": "Category",
			  "templateOptions": {
			    "label": "Category"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUpdatedOn() : FormlyFieldConfig {
			return {
			  "key": "UpdatedOn",
			  "name": "UpdatedOn",
			  "templateOptions": {
			    "type": "Date",
			    "label": "UpdatedOn"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAttachments() : FormlyFieldConfig {
			return {
			  "key": "Attachments",
			  "name": "Attachments",
			  "templateOptions": {
			    "label": "Attachments"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAttachmentsJson() : FormlyFieldConfig {
			return {
			  "key": "AttachmentsJson",
			  "name": "AttachmentsJson",
			  "templateOptions": {
			    "label": "AttachmentsJson"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActiveDays() : FormlyFieldConfig {
			return {
			  "key": "ActiveDays",
			  "name": "ActiveDays",
			  "templateOptions": {
			    "type": "number",
			    "label": "ActiveDays"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigCreatedBy() : FormlyFieldConfig {
			return {
			  "key": "CreatedBy",
			  "name": "CreatedBy",
			  "templateOptions": {
			    "label": "CreatedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreatedDate() : FormlyFieldConfig {
			return {
			  "key": "CreatedDate",
			  "name": "CreatedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreatedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedBy() : FormlyFieldConfig {
			return {
			  "key": "ModifiedBy",
			  "name": "ModifiedBy",
			  "templateOptions": {
			    "label": "ModifiedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsForProPak() : FormlyFieldConfig {
			return {
			  "key": "IsForProPak",
			  "name": "IsForProPak",
			  "templateOptions": {
			    "label": "IsForProPak"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIsForClientDash() : FormlyFieldConfig {
			return {
			  "key": "IsForClientDash",
			  "name": "IsForClientDash",
			  "templateOptions": {
			    "label": "IsForClientDash"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SystemUpdateDto.FormlyConfigId,
				SystemUpdateDto.FormlyConfigTitle,
				SystemUpdateDto.FormlyConfigContent,
				SystemUpdateDto.FormlyConfigCategory,
				SystemUpdateDto.FormlyConfigUpdatedOn,
				SystemUpdateDto.FormlyConfigAttachments,
				SystemUpdateDto.FormlyConfigAttachmentsJson,
				SystemUpdateDto.FormlyConfigActiveDays,
				SystemUpdateDto.FormlyConfigIsActive,
				SystemUpdateDto.FormlyConfigCreatedBy,
				SystemUpdateDto.FormlyConfigCreatedDate,
				SystemUpdateDto.FormlyConfigModifiedBy,
				SystemUpdateDto.FormlyConfigModifiedDate,
				SystemUpdateDto.FormlyConfigIsForProPak,
				SystemUpdateDto.FormlyConfigIsForClientDash
			];
		};
	}

	export class TARApprovalDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				TARApprovalDto.FormlyConfigId,
				TARApprovalDto.FormlyConfigDescription,
				TARApprovalDto.FormlyConfigValue,
				TARApprovalDto.FormlyConfigWeight,
				TARApprovalDto.FormlyConfigIsActive,
				TARApprovalDto.FormlyConfigModifiedByUserId,
				TARApprovalDto.FormlyConfigModifiedDate
			];
		};
	}

	export class TaskDto {
		id: number;
		text: string;
		start_date: string;
		duration: number;
		progress: number;
		type: string;
		parent: number;
		open: boolean;
		end_date: string;
		editable: boolean;

		static get FormlyConfigid() : FormlyFieldConfig {
			return {
			  "key": "id",
			  "name": "id",
			  "templateOptions": {
			    "type": "number",
			    "label": "id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtext() : FormlyFieldConfig {
			return {
			  "key": "text",
			  "name": "text",
			  "templateOptions": {
			    "label": "text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigstart_date() : FormlyFieldConfig {
			return {
			  "key": "start_date",
			  "name": "start_date",
			  "templateOptions": {
			    "label": "start_date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigduration() : FormlyFieldConfig {
			return {
			  "key": "duration",
			  "name": "duration",
			  "templateOptions": {
			    "type": "number",
			    "label": "duration"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigprogress() : FormlyFieldConfig {
			return {
			  "key": "progress",
			  "name": "progress",
			  "templateOptions": {
			    "type": "number",
			    "label": "progress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigtype() : FormlyFieldConfig {
			return {
			  "key": "type",
			  "name": "type",
			  "templateOptions": {
			    "label": "type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigparent() : FormlyFieldConfig {
			return {
			  "key": "parent",
			  "name": "parent",
			  "templateOptions": {
			    "type": "number",
			    "label": "parent"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigopen() : FormlyFieldConfig {
			return {
			  "key": "open",
			  "name": "open",
			  "templateOptions": {
			    "label": "open"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigend_date() : FormlyFieldConfig {
			return {
			  "key": "end_date",
			  "name": "end_date",
			  "templateOptions": {
			    "label": "end_date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigeditable() : FormlyFieldConfig {
			return {
			  "key": "editable",
			  "name": "editable",
			  "templateOptions": {
			    "label": "editable"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				TaskDto.FormlyConfigid,
				TaskDto.FormlyConfigtext,
				TaskDto.FormlyConfigstart_date,
				TaskDto.FormlyConfigduration,
				TaskDto.FormlyConfigprogress,
				TaskDto.FormlyConfigtype,
				TaskDto.FormlyConfigparent,
				TaskDto.FormlyConfigopen,
				TaskDto.FormlyConfigend_date,
				TaskDto.FormlyConfigeditable
			];
		};
	}

	export class UserDto {
		Id: number;
		Username: string;
		FirstName: string;
		LastName: string;
		Email: string;
		Active: boolean;
		LogCommands: boolean;
		UserRoleDtos: UserRoleDto[] = [];

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEmail() : FormlyFieldConfig {
			return {
			  "key": "Email",
			  "name": "Email",
			  "templateOptions": {
			    "label": "Email"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigLogCommands() : FormlyFieldConfig {
			return {
			  "key": "LogCommands",
			  "name": "LogCommands",
			  "templateOptions": {
			    "label": "LogCommands"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigUserRoleDtos() : FormlyFieldConfig {
			return {
			  "key": "UserRoleDtos",
			  "name": "UserRoleDtos",
			  "templateOptions": {
			    "label": "UserRoleDtos",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserDto.FormlyConfigId,
				UserDto.FormlyConfigUsername,
				UserDto.FormlyConfigFirstName,
				UserDto.FormlyConfigLastName,
				UserDto.FormlyConfigEmail,
				UserDto.FormlyConfigActive,
				UserDto.FormlyConfigLogCommands,
				UserDto.FormlyConfigUserRoleDtos
			];
		};
	}

	export class UserInfoDto {
		Id: number;
		UserName: string;
		FirstName: string;
		LastName: string;
		Roles: ValueTextDto[] = [];
		EmailAddress: string;
		LogCommands: boolean;
		Checkpoints: CommandSecurityCheckpointDto[] = [];

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserName() : FormlyFieldConfig {
			return {
			  "key": "UserName",
			  "name": "UserName",
			  "templateOptions": {
			    "label": "UserName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoles() : FormlyFieldConfig {
			return {
			  "key": "Roles",
			  "name": "Roles",
			  "templateOptions": {
			    "label": "Roles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigEmailAddress() : FormlyFieldConfig {
			return {
			  "key": "EmailAddress",
			  "name": "EmailAddress",
			  "templateOptions": {
			    "label": "EmailAddress"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLogCommands() : FormlyFieldConfig {
			return {
			  "key": "LogCommands",
			  "name": "LogCommands",
			  "templateOptions": {
			    "label": "LogCommands"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigCheckpoints() : FormlyFieldConfig {
			return {
			  "key": "Checkpoints",
			  "name": "Checkpoints",
			  "templateOptions": {
			    "label": "Checkpoints",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserInfoDto.FormlyConfigId,
				UserInfoDto.FormlyConfigUserName,
				UserInfoDto.FormlyConfigFirstName,
				UserInfoDto.FormlyConfigLastName,
				UserInfoDto.FormlyConfigRoles,
				UserInfoDto.FormlyConfigEmailAddress,
				UserInfoDto.FormlyConfigLogCommands,
				UserInfoDto.FormlyConfigCheckpoints
			];
		};
	}

	export class UserRoleDto {
		RoleId: number;
		RoleName: string;
		IsSelected: boolean;

		static get FormlyConfigRoleId() : FormlyFieldConfig {
			return {
			  "key": "RoleId",
			  "name": "RoleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "RoleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoleName() : FormlyFieldConfig {
			return {
			  "key": "RoleName",
			  "name": "RoleName",
			  "templateOptions": {
			    "label": "RoleName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsSelected() : FormlyFieldConfig {
			return {
			  "key": "IsSelected",
			  "name": "IsSelected",
			  "templateOptions": {
			    "label": "IsSelected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserRoleDto.FormlyConfigRoleId,
				UserRoleDto.FormlyConfigRoleName,
				UserRoleDto.FormlyConfigIsSelected
			];
		};
	}

	export class UserSearchRow {
		Id: number;
		FirstName: string;
		LastName: string;
		Email: string;
		Active: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEmail() : FormlyFieldConfig {
			return {
			  "key": "Email",
			  "name": "Email",
			  "templateOptions": {
			    "label": "Email"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActive() : FormlyFieldConfig {
			return {
			  "key": "Active",
			  "name": "Active",
			  "templateOptions": {
			    "label": "Active"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserSearchRow.FormlyConfigId,
				UserSearchRow.FormlyConfigFirstName,
				UserSearchRow.FormlyConfigLastName,
				UserSearchRow.FormlyConfigEmail,
				UserSearchRow.FormlyConfigActive
			];
		};
	}

	export class UserSessionFilter {
		Pager: Pager = new Pager();
		UserId: number;
		FromDate: Date;
		ToDate: Date;
		currentUsername: string;
		TimeZone: string;

		static get FormlyConfigPager() : FormlyFieldConfig {
			return {
			  "key": "Pager",
			  "name": "Pager",
			  "templateOptions": {
			    "type": "Pager = new Pager()",
			    "label": "Pager"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserId() : FormlyFieldConfig {
			return {
			  "key": "UserId",
			  "name": "UserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "UserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFromDate() : FormlyFieldConfig {
			return {
			  "key": "FromDate",
			  "name": "FromDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "FromDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigToDate() : FormlyFieldConfig {
			return {
			  "key": "ToDate",
			  "name": "ToDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ToDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigcurrentUsername() : FormlyFieldConfig {
			return {
			  "key": "currentUsername",
			  "name": "currentUsername",
			  "templateOptions": {
			    "label": "currentUsername"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeZone() : FormlyFieldConfig {
			return {
			  "key": "TimeZone",
			  "name": "TimeZone",
			  "templateOptions": {
			    "label": "TimeZone"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserSessionFilter.FormlyConfigPager,
				UserSessionFilter.FormlyConfigUserId,
				UserSessionFilter.FormlyConfigFromDate,
				UserSessionFilter.FormlyConfigToDate,
				UserSessionFilter.FormlyConfigcurrentUsername,
				UserSessionFilter.FormlyConfigTimeZone
			];
		};
	}

	export class ValueLabelDto {
		value: any;
		label: string;

		static get FormlyConfigvalue() : FormlyFieldConfig {
			return {
			  "key": "value",
			  "name": "value",
			  "templateOptions": {
			    "type": "any",
			    "label": "value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfiglabel() : FormlyFieldConfig {
			return {
			  "key": "label",
			  "name": "label",
			  "templateOptions": {
			    "label": "label"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueLabelDto.FormlyConfigvalue,
				ValueLabelDto.FormlyConfiglabel
			];
		};
	}

	export class ValueSelectedDto {
		Value: any;
		Selected: boolean;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueSelectedDto.FormlyConfigValue,
				ValueSelectedDto.FormlyConfigSelected
			];
		};
	}

	export class ValueTextDescriptionDto {
		Value: any;
		Text: string;
		Description: string;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueTextDescriptionDto.FormlyConfigValue,
				ValueTextDescriptionDto.FormlyConfigText,
				ValueTextDescriptionDto.FormlyConfigDescription
			];
		};
	}

	export class ValueTextDto {
		Value: any;
		Text: string;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueTextDto.FormlyConfigValue,
				ValueTextDto.FormlyConfigText
			];
		};
	}

	export class ValueTextSelectedDto {
		Value: any;
		Text: string;
		Selected: boolean;

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "any",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigText() : FormlyFieldConfig {
			return {
			  "key": "Text",
			  "name": "Text",
			  "templateOptions": {
			    "label": "Text"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ValueTextSelectedDto.FormlyConfigValue,
				ValueTextSelectedDto.FormlyConfigText,
				ValueTextSelectedDto.FormlyConfigSelected
			];
		};
	}

	export class vw_UserSessionDto {
		UserLoginName: string;
		Date: Date;
		SessionStart: Date;
		LastPostback: Date;
		UserActiveHours: string;
		UserRequestCount: number;

		static get FormlyConfigUserLoginName() : FormlyFieldConfig {
			return {
			  "key": "UserLoginName",
			  "name": "UserLoginName",
			  "templateOptions": {
			    "label": "UserLoginName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDate() : FormlyFieldConfig {
			return {
			  "key": "Date",
			  "name": "Date",
			  "templateOptions": {
			    "type": "Date",
			    "label": "Date"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSessionStart() : FormlyFieldConfig {
			return {
			  "key": "SessionStart",
			  "name": "SessionStart",
			  "templateOptions": {
			    "type": "Date",
			    "label": "SessionStart"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastPostback() : FormlyFieldConfig {
			return {
			  "key": "LastPostback",
			  "name": "LastPostback",
			  "templateOptions": {
			    "type": "Date",
			    "label": "LastPostback"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserActiveHours() : FormlyFieldConfig {
			return {
			  "key": "UserActiveHours",
			  "name": "UserActiveHours",
			  "templateOptions": {
			    "label": "UserActiveHours"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserRequestCount() : FormlyFieldConfig {
			return {
			  "key": "UserRequestCount",
			  "name": "UserRequestCount",
			  "templateOptions": {
			    "type": "number",
			    "label": "UserRequestCount"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				vw_UserSessionDto.FormlyConfigUserLoginName,
				vw_UserSessionDto.FormlyConfigDate,
				vw_UserSessionDto.FormlyConfigSessionStart,
				vw_UserSessionDto.FormlyConfigLastPostback,
				vw_UserSessionDto.FormlyConfigUserActiveHours,
				vw_UserSessionDto.FormlyConfigUserRequestCount
			];
		};
	}

	export class WidgetDto {
		Id: number;
		Order: number;
		WidgetType: WidgetType;
		Selected: boolean;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigOrder() : FormlyFieldConfig {
			return {
			  "key": "Order",
			  "name": "Order",
			  "templateOptions": {
			    "type": "number",
			    "label": "Order"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWidgetType() : FormlyFieldConfig {
			return {
			  "key": "WidgetType",
			  "name": "WidgetType",
			  "templateOptions": {
			    "type": "WidgetType = new WidgetType()",
			    "label": "WidgetType",
			    "options": [
			      {
			        "label": "Count",
			        "value": "0"
			      }
			    ]
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSelected() : FormlyFieldConfig {
			return {
			  "key": "Selected",
			  "name": "Selected",
			  "templateOptions": {
			    "label": "Selected"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				WidgetDto.FormlyConfigId,
				WidgetDto.FormlyConfigOrder,
				WidgetDto.FormlyConfigWidgetType,
				WidgetDto.FormlyConfigSelected
			];
		};
	}

	export class WorkPackDto {
		WorkPackId: number;
		ProjectId: number;
		Number: string;
		Description: string;
		ApprovedDate: Date;
		ApprovedBy: string;
		CreatedDate: Date;
		CreatedBy: string;
		ModifiedDate: Date;
		ModifiedBy: string;
		IsArchived: boolean;

		static get FormlyConfigWorkPackId() : FormlyFieldConfig {
			return {
			  "key": "WorkPackId",
			  "name": "WorkPackId",
			  "templateOptions": {
			    "type": "number",
			    "label": "WorkPackId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigNumber() : FormlyFieldConfig {
			return {
			  "key": "Number",
			  "name": "Number",
			  "templateOptions": {
			    "label": "Number"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigApprovedDate() : FormlyFieldConfig {
			return {
			  "key": "ApprovedDate",
			  "name": "ApprovedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ApprovedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigApprovedBy() : FormlyFieldConfig {
			return {
			  "key": "ApprovedBy",
			  "name": "ApprovedBy",
			  "templateOptions": {
			    "label": "ApprovedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreatedDate() : FormlyFieldConfig {
			return {
			  "key": "CreatedDate",
			  "name": "CreatedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "CreatedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCreatedBy() : FormlyFieldConfig {
			return {
			  "key": "CreatedBy",
			  "name": "CreatedBy",
			  "templateOptions": {
			    "label": "CreatedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedBy() : FormlyFieldConfig {
			return {
			  "key": "ModifiedBy",
			  "name": "ModifiedBy",
			  "templateOptions": {
			    "label": "ModifiedBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsArchived() : FormlyFieldConfig {
			return {
			  "key": "IsArchived",
			  "name": "IsArchived",
			  "templateOptions": {
			    "label": "IsArchived"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				WorkPackDto.FormlyConfigWorkPackId,
				WorkPackDto.FormlyConfigProjectId,
				WorkPackDto.FormlyConfigNumber,
				WorkPackDto.FormlyConfigDescription,
				WorkPackDto.FormlyConfigApprovedDate,
				WorkPackDto.FormlyConfigApprovedBy,
				WorkPackDto.FormlyConfigCreatedDate,
				WorkPackDto.FormlyConfigCreatedBy,
				WorkPackDto.FormlyConfigModifiedDate,
				WorkPackDto.FormlyConfigModifiedBy,
				WorkPackDto.FormlyConfigIsArchived
			];
		};
	}

	export class WorkPackRequiredDto {
		Id: number;
		Description: string;
		Value: number;
		Weight: number;
		IsActive: boolean = true;
		ModifiedByUserId: number;
		ModifiedDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDescription() : FormlyFieldConfig {
			return {
			  "key": "Description",
			  "name": "Description",
			  "templateOptions": {
			    "label": "Description"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "type": "number",
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigWeight() : FormlyFieldConfig {
			return {
			  "key": "Weight",
			  "name": "Weight",
			  "templateOptions": {
			    "type": "number",
			    "label": "Weight"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsActive() : FormlyFieldConfig {
			return {
			  "key": "IsActive",
			  "name": "IsActive",
			  "templateOptions": {
			    "label": "IsActive"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigModifiedByUserId() : FormlyFieldConfig {
			return {
			  "key": "ModifiedByUserId",
			  "name": "ModifiedByUserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ModifiedByUserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigModifiedDate() : FormlyFieldConfig {
			return {
			  "key": "ModifiedDate",
			  "name": "ModifiedDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ModifiedDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				WorkPackRequiredDto.FormlyConfigId,
				WorkPackRequiredDto.FormlyConfigDescription,
				WorkPackRequiredDto.FormlyConfigValue,
				WorkPackRequiredDto.FormlyConfigWeight,
				WorkPackRequiredDto.FormlyConfigIsActive,
				WorkPackRequiredDto.FormlyConfigModifiedByUserId,
				WorkPackRequiredDto.FormlyConfigModifiedDate
			];
		};
	}

	export class AddUpdateSupportTicketCommandRequest {
		supportTicket: SupportTicketDto = new SupportTicketDto();

		static get FormlyConfigsupportTicket() : FormlyFieldConfig {
			return {
			  "key": "supportTicket",
			  "name": "supportTicket",
			  "templateOptions": {
			    "type": "SupportTicketDto = new SupportTicketDto()",
			    "label": "supportTicket"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AddUpdateSupportTicketCommandRequest.FormlyConfigsupportTicket
			];
		};
	}

	export class AdminCommandRequest {
		ProPakProjectId: number;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AdminCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class AskDataQuestionCommandRequest {
		ProjectId: number;
		Question: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigQuestion() : FormlyFieldConfig {
			return {
			  "key": "Question",
			  "name": "Question",
			  "templateOptions": {
			    "label": "Question"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				AskDataQuestionCommandRequest.FormlyConfigProjectId,
				AskDataQuestionCommandRequest.FormlyConfigQuestion
			];
		};
	}

	export class CreateReadinessExcelReportCommandRequest {
		ProjectId: number;
		TaskExportType: string;
		IncludeTaskImages: boolean;
		IncludeArchivedTaskImages: boolean;
		ApplyClientTaskFilter: boolean;
		OrderedExportTasks: ReadinessExportTaskRef[] = [];

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskExportType() : FormlyFieldConfig {
			return {
			  "key": "TaskExportType",
			  "name": "TaskExportType",
			  "templateOptions": {
			    "label": "TaskExportType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIncludeTaskImages() : FormlyFieldConfig {
			return {
			  "key": "IncludeTaskImages",
			  "name": "IncludeTaskImages",
			  "templateOptions": {
			    "label": "IncludeTaskImages"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIncludeArchivedTaskImages() : FormlyFieldConfig {
			return {
			  "key": "IncludeArchivedTaskImages",
			  "name": "IncludeArchivedTaskImages",
			  "templateOptions": {
			    "label": "IncludeArchivedTaskImages"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigApplyClientTaskFilter() : FormlyFieldConfig {
			return {
			  "key": "ApplyClientTaskFilter",
			  "name": "ApplyClientTaskFilter",
			  "templateOptions": {
			    "label": "ApplyClientTaskFilter"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigOrderedExportTasks() : FormlyFieldConfig {
			return {
			  "key": "OrderedExportTasks",
			  "name": "OrderedExportTasks",
			  "templateOptions": {
			    "label": "OrderedExportTasks",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CreateReadinessExcelReportCommandRequest.FormlyConfigProjectId,
				CreateReadinessExcelReportCommandRequest.FormlyConfigTaskExportType,
				CreateReadinessExcelReportCommandRequest.FormlyConfigIncludeTaskImages,
				CreateReadinessExcelReportCommandRequest.FormlyConfigIncludeArchivedTaskImages,
				CreateReadinessExcelReportCommandRequest.FormlyConfigApplyClientTaskFilter,
				CreateReadinessExcelReportCommandRequest.FormlyConfigOrderedExportTasks
			];
		};
	}

	export class CreateReadinessPdfReportCommandRequest {
		ProjectId: number;
		TaskExportType: string;
		SectionVisibility: { [key: string]: boolean };
		IncludeTaskImages: boolean;
		IncludeArchivedTaskImages: boolean;
		ApplyClientTaskFilter: boolean;
		OrderedExportTasks: ReadinessExportTaskRef[] = [];

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskExportType() : FormlyFieldConfig {
			return {
			  "key": "TaskExportType",
			  "name": "TaskExportType",
			  "templateOptions": {
			    "label": "TaskExportType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSectionVisibility() : FormlyFieldConfig {
			return {
			  "key": "SectionVisibility",
			  "name": "SectionVisibility",
			  "templateOptions": {
			    "type": "{ [key: string]: boolean }",
			    "label": "SectionVisibility"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIncludeTaskImages() : FormlyFieldConfig {
			return {
			  "key": "IncludeTaskImages",
			  "name": "IncludeTaskImages",
			  "templateOptions": {
			    "label": "IncludeTaskImages"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigIncludeArchivedTaskImages() : FormlyFieldConfig {
			return {
			  "key": "IncludeArchivedTaskImages",
			  "name": "IncludeArchivedTaskImages",
			  "templateOptions": {
			    "label": "IncludeArchivedTaskImages"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigApplyClientTaskFilter() : FormlyFieldConfig {
			return {
			  "key": "ApplyClientTaskFilter",
			  "name": "ApplyClientTaskFilter",
			  "templateOptions": {
			    "label": "ApplyClientTaskFilter"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigOrderedExportTasks() : FormlyFieldConfig {
			return {
			  "key": "OrderedExportTasks",
			  "name": "OrderedExportTasks",
			  "templateOptions": {
			    "label": "OrderedExportTasks",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CreateReadinessPdfReportCommandRequest.FormlyConfigProjectId,
				CreateReadinessPdfReportCommandRequest.FormlyConfigTaskExportType,
				CreateReadinessPdfReportCommandRequest.FormlyConfigSectionVisibility,
				CreateReadinessPdfReportCommandRequest.FormlyConfigIncludeTaskImages,
				CreateReadinessPdfReportCommandRequest.FormlyConfigIncludeArchivedTaskImages,
				CreateReadinessPdfReportCommandRequest.FormlyConfigApplyClientTaskFilter,
				CreateReadinessPdfReportCommandRequest.FormlyConfigOrderedExportTasks
			];
		};
	}

	export class CreateTestDummyCommandQueueCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class CreateUserCommandRequest {
		Username: string;
		Password: string;
		FirstName: string;
		LastName: string;
		Email: string;
		Roles: ValueTextDto[] = [];

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPassword() : FormlyFieldConfig {
			return {
			  "key": "Password",
			  "name": "Password",
			  "templateOptions": {
			    "label": "Password"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFirstName() : FormlyFieldConfig {
			return {
			  "key": "FirstName",
			  "name": "FirstName",
			  "templateOptions": {
			    "label": "FirstName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigLastName() : FormlyFieldConfig {
			return {
			  "key": "LastName",
			  "name": "LastName",
			  "templateOptions": {
			    "label": "LastName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEmail() : FormlyFieldConfig {
			return {
			  "key": "Email",
			  "name": "Email",
			  "templateOptions": {
			    "label": "Email"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoles() : FormlyFieldConfig {
			return {
			  "key": "Roles",
			  "name": "Roles",
			  "templateOptions": {
			    "label": "Roles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				CreateUserCommandRequest.FormlyConfigUsername,
				CreateUserCommandRequest.FormlyConfigPassword,
				CreateUserCommandRequest.FormlyConfigFirstName,
				CreateUserCommandRequest.FormlyConfigLastName,
				CreateUserCommandRequest.FormlyConfigEmail,
				CreateUserCommandRequest.FormlyConfigRoles
			];
		};
	}

	export class DeleteArchiveProjectTasksCommandRequest {
		taskIds: number[] = [];

		static get FormlyConfigtaskIds() : FormlyFieldConfig {
			return {
			  "key": "taskIds",
			  "name": "taskIds",
			  "templateOptions": {
			    "label": "taskIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteArchiveProjectTasksCommandRequest.FormlyConfigtaskIds
			];
		};
	}

	export class DeleteCheckpointCommandRequest {
		CommandSecurityRoleId: number;

		static get FormlyConfigCommandSecurityRoleId() : FormlyFieldConfig {
			return {
			  "key": "CommandSecurityRoleId",
			  "name": "CommandSecurityRoleId",
			  "templateOptions": {
			    "type": "number",
			    "label": "CommandSecurityRoleId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteCheckpointCommandRequest.FormlyConfigCommandSecurityRoleId
			];
		};
	}

	export class DeleteExampleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteExampleCommandRequest.FormlyConfigId
			];
		};
	}

	export class DeleteReadinessImageCommandRequest {
		ImageUrl: string;

		static get FormlyConfigImageUrl() : FormlyFieldConfig {
			return {
			  "key": "ImageUrl",
			  "name": "ImageUrl",
			  "templateOptions": {
			    "label": "ImageUrl"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteReadinessImageCommandRequest.FormlyConfigImageUrl
			];
		};
	}

	export class DeleteReadinessTaskCommandRequest {
		ReadinessTasksIds: number[] = [];

		static get FormlyConfigReadinessTasksIds() : FormlyFieldConfig {
			return {
			  "key": "ReadinessTasksIds",
			  "name": "ReadinessTasksIds",
			  "templateOptions": {
			    "label": "ReadinessTasksIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteReadinessTaskCommandRequest.FormlyConfigReadinessTasksIds
			];
		};
	}

	export class DeleteRoleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				DeleteRoleCommandRequest.FormlyConfigId
			];
		};
	}

	export class ExecuteAllPendingQueuesCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ExecuteNextQueueEntryCommandRequest {
		QueueDefinition: BatchProcessingQueueDefinition;
		QueueEntryId: number;

		static get FormlyConfigQueueDefinition() : FormlyFieldConfig {
			return {
			  "key": "QueueDefinition",
			  "name": "QueueDefinition",
			  "templateOptions": {
			    "type": "BatchProcessingQueueDefinition = new BatchProcessingQueueDefinition()",
			    "label": "QueueDefinition"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigQueueEntryId() : FormlyFieldConfig {
			return {
			  "key": "QueueEntryId",
			  "name": "QueueEntryId",
			  "templateOptions": {
			    "type": "number",
			    "label": "QueueEntryId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecuteNextQueueEntryCommandRequest.FormlyConfigQueueDefinition,
				ExecuteNextQueueEntryCommandRequest.FormlyConfigQueueEntryId
			];
		};
	}

	export class ExecutePendingQueueEntriesCommandRequest {
		QueueDefinition: BatchProcessingQueueDefinition;

		static get FormlyConfigQueueDefinition() : FormlyFieldConfig {
			return {
			  "key": "QueueDefinition",
			  "name": "QueueDefinition",
			  "templateOptions": {
			    "type": "BatchProcessingQueueDefinition = new BatchProcessingQueueDefinition()",
			    "label": "QueueDefinition",
			    "options": [
			      {
			        "label": "TestDummy",
			        "value": "1"
			      },
			      {
			        "label": "Email",
			        "value": "2"
			      }
			    ]
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExecutePendingQueueEntriesCommandRequest.FormlyConfigQueueDefinition
			];
		};
	}

	export class ExportUserSessionsExcelCommandRequest {
		CurrentUsername: string;
		UserId: number;
		FromDate: string;
		ToDate: string;
		GroupBy: string;
		TimeZone: string;

		static get FormlyConfigCurrentUsername() : FormlyFieldConfig {
			return {
			  "key": "CurrentUsername",
			  "name": "CurrentUsername",
			  "templateOptions": {
			    "label": "CurrentUsername"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUserId() : FormlyFieldConfig {
			return {
			  "key": "UserId",
			  "name": "UserId",
			  "templateOptions": {
			    "type": "number",
			    "label": "UserId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFromDate() : FormlyFieldConfig {
			return {
			  "key": "FromDate",
			  "name": "FromDate",
			  "templateOptions": {
			    "label": "FromDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigToDate() : FormlyFieldConfig {
			return {
			  "key": "ToDate",
			  "name": "ToDate",
			  "templateOptions": {
			    "label": "ToDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigGroupBy() : FormlyFieldConfig {
			return {
			  "key": "GroupBy",
			  "name": "GroupBy",
			  "templateOptions": {
			    "label": "GroupBy"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeZone() : FormlyFieldConfig {
			return {
			  "key": "TimeZone",
			  "name": "TimeZone",
			  "templateOptions": {
			    "label": "TimeZone"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ExportUserSessionsExcelCommandRequest.FormlyConfigCurrentUsername,
				ExportUserSessionsExcelCommandRequest.FormlyConfigUserId,
				ExportUserSessionsExcelCommandRequest.FormlyConfigFromDate,
				ExportUserSessionsExcelCommandRequest.FormlyConfigToDate,
				ExportUserSessionsExcelCommandRequest.FormlyConfigGroupBy,
				ExportUserSessionsExcelCommandRequest.FormlyConfigTimeZone
			];
		};
	}

	export class GetApplicationSettingCommandRequest {
		SettingName: string;

		static get FormlyConfigSettingName() : FormlyFieldConfig {
			return {
			  "key": "SettingName",
			  "name": "SettingName",
			  "templateOptions": {
			    "label": "SettingName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetApplicationSettingCommandRequest.FormlyConfigSettingName
			];
		};
	}

	export class GetArchiveTaskCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetArchiveTaskCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetCheckpointCommandRequest {
		SecurityCheckpointId: number;

		static get FormlyConfigSecurityCheckpointId() : FormlyFieldConfig {
			return {
			  "key": "SecurityCheckpointId",
			  "name": "SecurityCheckpointId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SecurityCheckpointId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetCheckpointCommandRequest.FormlyConfigSecurityCheckpointId
			];
		};
	}

	export class GetClientAndAssetListByUserCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetCountryCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetCountryCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetDashboardCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetExampleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExampleCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetExceptionCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExceptionCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetExecutionBarChartCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionBarChartCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetExecutionChartCommandRequest {
		ProjectId: number;
		StartDate: Date;
		EndDate: Date;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStartDate() : FormlyFieldConfig {
			return {
			  "key": "StartDate",
			  "name": "StartDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "StartDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigEndDate() : FormlyFieldConfig {
			return {
			  "key": "EndDate",
			  "name": "EndDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "EndDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionChartCommandRequest.FormlyConfigProjectId,
				GetExecutionChartCommandRequest.FormlyConfigStartDate,
				GetExecutionChartCommandRequest.FormlyConfigEndDate
			];
		};
	}

	export class GetExecutionCurrentStatusChartCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionCurrentStatusChartCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetExecutionStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetExecutionStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetFeatureCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetMaterialsStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetMaterialsStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetP6ReportingLinkCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetP6ReportingLinkCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetPrimaveraSummaryReportCommandRequest {
		ProPakProjectId: number;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetPrimaveraSummaryReportCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class GetProjectAiInsightsCommandRequest {
		ProjectId: number;
		FactsJson: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFactsJson() : FormlyFieldConfig {
			return {
			  "key": "FactsJson",
			  "name": "FactsJson",
			  "templateOptions": {
			    "label": "FactsJson"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectAiInsightsCommandRequest.FormlyConfigProjectId,
				GetProjectAiInsightsCommandRequest.FormlyConfigFactsJson
			];
		};
	}

	export class GetProjectCardMetricsCommandRequest {
		ProjectIds: number[] = [];
		ExcludeProjectIds: number[] = [];
		UseUserProjectQuery: boolean;
		Page: number;
		PageSize: number;
		Skip: number;
		ClientId: number;
		AssetId: number;
		ActiveFilter: string;
		Search: string;
		Sort: string;
		FavoriteProjectIds: number[] = [];

		static get FormlyConfigProjectIds() : FormlyFieldConfig {
			return {
			  "key": "ProjectIds",
			  "name": "ProjectIds",
			  "templateOptions": {
			    "label": "ProjectIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigExcludeProjectIds() : FormlyFieldConfig {
			return {
			  "key": "ExcludeProjectIds",
			  "name": "ExcludeProjectIds",
			  "templateOptions": {
			    "label": "ExcludeProjectIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigUseUserProjectQuery() : FormlyFieldConfig {
			return {
			  "key": "UseUserProjectQuery",
			  "name": "UseUserProjectQuery",
			  "templateOptions": {
			    "label": "UseUserProjectQuery"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigPage() : FormlyFieldConfig {
			return {
			  "key": "Page",
			  "name": "Page",
			  "templateOptions": {
			    "type": "number",
			    "label": "Page"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPageSize() : FormlyFieldConfig {
			return {
			  "key": "PageSize",
			  "name": "PageSize",
			  "templateOptions": {
			    "type": "number",
			    "label": "PageSize"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSkip() : FormlyFieldConfig {
			return {
			  "key": "Skip",
			  "name": "Skip",
			  "templateOptions": {
			    "type": "number",
			    "label": "Skip"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigClientId() : FormlyFieldConfig {
			return {
			  "key": "ClientId",
			  "name": "ClientId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ClientId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAssetId() : FormlyFieldConfig {
			return {
			  "key": "AssetId",
			  "name": "AssetId",
			  "templateOptions": {
			    "type": "number",
			    "label": "AssetId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActiveFilter() : FormlyFieldConfig {
			return {
			  "key": "ActiveFilter",
			  "name": "ActiveFilter",
			  "templateOptions": {
			    "label": "ActiveFilter"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSearch() : FormlyFieldConfig {
			return {
			  "key": "Search",
			  "name": "Search",
			  "templateOptions": {
			    "label": "Search"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSort() : FormlyFieldConfig {
			return {
			  "key": "Sort",
			  "name": "Sort",
			  "templateOptions": {
			    "label": "Sort"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFavoriteProjectIds() : FormlyFieldConfig {
			return {
			  "key": "FavoriteProjectIds",
			  "name": "FavoriteProjectIds",
			  "templateOptions": {
			    "label": "FavoriteProjectIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectCardMetricsCommandRequest.FormlyConfigProjectIds,
				GetProjectCardMetricsCommandRequest.FormlyConfigExcludeProjectIds,
				GetProjectCardMetricsCommandRequest.FormlyConfigUseUserProjectQuery,
				GetProjectCardMetricsCommandRequest.FormlyConfigPage,
				GetProjectCardMetricsCommandRequest.FormlyConfigPageSize,
				GetProjectCardMetricsCommandRequest.FormlyConfigSkip,
				GetProjectCardMetricsCommandRequest.FormlyConfigClientId,
				GetProjectCardMetricsCommandRequest.FormlyConfigAssetId,
				GetProjectCardMetricsCommandRequest.FormlyConfigActiveFilter,
				GetProjectCardMetricsCommandRequest.FormlyConfigSearch,
				GetProjectCardMetricsCommandRequest.FormlyConfigSort,
				GetProjectCardMetricsCommandRequest.FormlyConfigFavoriteProjectIds
			];
		};
	}

	export class GetProjectModuleDisplaySettingsCommandRequest {
		ProPakProjectId: number;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectModuleDisplaySettingsCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class GetProjectsByUserCommandRequest {
		Page: number;
		PageSize: number;
		Skip: number;
		ClientId: number;
		AssetId: number;
		ActiveFilter: string;
		Search: string;
		Sort: string;
		FavoriteProjectIds: number[] = [];

		static get FormlyConfigPage() : FormlyFieldConfig {
			return {
			  "key": "Page",
			  "name": "Page",
			  "templateOptions": {
			    "type": "number",
			    "label": "Page"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPageSize() : FormlyFieldConfig {
			return {
			  "key": "PageSize",
			  "name": "PageSize",
			  "templateOptions": {
			    "type": "number",
			    "label": "PageSize"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSkip() : FormlyFieldConfig {
			return {
			  "key": "Skip",
			  "name": "Skip",
			  "templateOptions": {
			    "type": "number",
			    "label": "Skip"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigClientId() : FormlyFieldConfig {
			return {
			  "key": "ClientId",
			  "name": "ClientId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ClientId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAssetId() : FormlyFieldConfig {
			return {
			  "key": "AssetId",
			  "name": "AssetId",
			  "templateOptions": {
			    "type": "number",
			    "label": "AssetId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigActiveFilter() : FormlyFieldConfig {
			return {
			  "key": "ActiveFilter",
			  "name": "ActiveFilter",
			  "templateOptions": {
			    "label": "ActiveFilter"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSearch() : FormlyFieldConfig {
			return {
			  "key": "Search",
			  "name": "Search",
			  "templateOptions": {
			    "label": "Search"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSort() : FormlyFieldConfig {
			return {
			  "key": "Sort",
			  "name": "Sort",
			  "templateOptions": {
			    "label": "Sort"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFavoriteProjectIds() : FormlyFieldConfig {
			return {
			  "key": "FavoriteProjectIds",
			  "name": "FavoriteProjectIds",
			  "templateOptions": {
			    "label": "FavoriteProjectIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectsByUserCommandRequest.FormlyConfigPage,
				GetProjectsByUserCommandRequest.FormlyConfigPageSize,
				GetProjectsByUserCommandRequest.FormlyConfigSkip,
				GetProjectsByUserCommandRequest.FormlyConfigClientId,
				GetProjectsByUserCommandRequest.FormlyConfigAssetId,
				GetProjectsByUserCommandRequest.FormlyConfigActiveFilter,
				GetProjectsByUserCommandRequest.FormlyConfigSearch,
				GetProjectsByUserCommandRequest.FormlyConfigSort,
				GetProjectsByUserCommandRequest.FormlyConfigFavoriteProjectIds
			];
		};
	}

	export class GetProjectsByUserSessionCommandRequest {
		Pager: Pager = new Pager();
		ProjectAccessDto: ProjectAccessDto = new ProjectAccessDto();

		static get FormlyConfigPager() : FormlyFieldConfig {
			return {
			  "key": "Pager",
			  "name": "Pager",
			  "templateOptions": {
			    "type": "Pager = new Pager()",
			    "label": "Pager"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProjectAccessDto() : FormlyFieldConfig {
			return {
			  "key": "ProjectAccessDto",
			  "name": "ProjectAccessDto",
			  "templateOptions": {
			    "type": "ProjectAccessDto = new ProjectAccessDto()",
			    "label": "ProjectAccessDto"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectsByUserSessionCommandRequest.FormlyConfigPager,
				GetProjectsByUserSessionCommandRequest.FormlyConfigProjectAccessDto
			];
		};
	}

	export class GetProjectSetupCommandRequest {
		ProjectId: number;
		logTimeIn: boolean;
		AccessArea: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfiglogTimeIn() : FormlyFieldConfig {
			return {
			  "key": "logTimeIn",
			  "name": "logTimeIn",
			  "templateOptions": {
			    "label": "logTimeIn"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigAccessArea() : FormlyFieldConfig {
			return {
			  "key": "AccessArea",
			  "name": "AccessArea",
			  "templateOptions": {
			    "label": "AccessArea"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetProjectSetupCommandRequest.FormlyConfigProjectId,
				GetProjectSetupCommandRequest.FormlyConfiglogTimeIn,
				GetProjectSetupCommandRequest.FormlyConfigAccessArea
			];
		};
	}

	export class GetQueueDetailCommandRequest {
		QueueName: string;

		static get FormlyConfigQueueName() : FormlyFieldConfig {
			return {
			  "key": "QueueName",
			  "name": "QueueName",
			  "templateOptions": {
			    "label": "QueueName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetQueueDetailCommandRequest.FormlyConfigQueueName
			];
		};
	}

	export class GetReadinessFormDataCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessFormDataCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetReadinessStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetReadinessSummaryCommandRequest {
		ProjectId: number;
		ProPakProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessSummaryCommandRequest.FormlyConfigProjectId,
				GetReadinessSummaryCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class GetReadinessTaskAttachmentCountsCommandRequest {
		ProjectTaskIds: number[] = [];

		static get FormlyConfigProjectTaskIds() : FormlyFieldConfig {
			return {
			  "key": "ProjectTaskIds",
			  "name": "ProjectTaskIds",
			  "templateOptions": {
			    "label": "ProjectTaskIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessTaskAttachmentCountsCommandRequest.FormlyConfigProjectTaskIds
			];
		};
	}

	export class GetReadinessTaskAttachmentsCommandRequest {
		ProjectTaskId: number;

		static get FormlyConfigProjectTaskId() : FormlyFieldConfig {
			return {
			  "key": "ProjectTaskId",
			  "name": "ProjectTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessTaskAttachmentsCommandRequest.FormlyConfigProjectTaskId
			];
		};
	}

	export class GetReadinessTrafficLightRuleCommandRequest {
		ProPakProjectId: number;
		SectionName: string;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSectionName() : FormlyFieldConfig {
			return {
			  "key": "SectionName",
			  "name": "SectionName",
			  "templateOptions": {
			    "label": "SectionName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetReadinessTrafficLightRuleCommandRequest.FormlyConfigProPakProjectId,
				GetReadinessTrafficLightRuleCommandRequest.FormlyConfigSectionName
			];
		};
	}

	export class GetReleaseNumberCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetRoleCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetRoleCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetSessionUsersCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetSupportTicketCommandRequest {
		Id: number;
		CurrentPage: number;
		PageSize: number;
		TotalItems: number;
		Status: number;
		FromDate: Date;
		ToDate: Date;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigCurrentPage() : FormlyFieldConfig {
			return {
			  "key": "CurrentPage",
			  "name": "CurrentPage",
			  "templateOptions": {
			    "type": "number",
			    "label": "CurrentPage"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPageSize() : FormlyFieldConfig {
			return {
			  "key": "PageSize",
			  "name": "PageSize",
			  "templateOptions": {
			    "type": "number",
			    "label": "PageSize"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTotalItems() : FormlyFieldConfig {
			return {
			  "key": "TotalItems",
			  "name": "TotalItems",
			  "templateOptions": {
			    "type": "number",
			    "label": "TotalItems"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStatus() : FormlyFieldConfig {
			return {
			  "key": "Status",
			  "name": "Status",
			  "templateOptions": {
			    "type": "number",
			    "label": "Status"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFromDate() : FormlyFieldConfig {
			return {
			  "key": "FromDate",
			  "name": "FromDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "FromDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigToDate() : FormlyFieldConfig {
			return {
			  "key": "ToDate",
			  "name": "ToDate",
			  "templateOptions": {
			    "type": "Date",
			    "label": "ToDate"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetSupportTicketCommandRequest.FormlyConfigId,
				GetSupportTicketCommandRequest.FormlyConfigCurrentPage,
				GetSupportTicketCommandRequest.FormlyConfigPageSize,
				GetSupportTicketCommandRequest.FormlyConfigTotalItems,
				GetSupportTicketCommandRequest.FormlyConfigStatus,
				GetSupportTicketCommandRequest.FormlyConfigFromDate,
				GetSupportTicketCommandRequest.FormlyConfigToDate
			];
		};
	}

	export class GetSystemUpdateCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetSystemUpdateCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetTaskPriorityStatusCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetTaskPriorityStatusCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetUserCommandRequest {
		Id: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetUserCommandRequest.FormlyConfigId
			];
		};
	}

	export class GetUserWidgetSelectionsCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class GetWorkpacksByProjectCommandRequest {
		ProjectId: number;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetWorkpacksByProjectCommandRequest.FormlyConfigProjectId
			];
		};
	}

	export class GetWorkPackTaskListReferenceCommandRequest {
		ProPakProjectId: number;
		TaskNumber: string;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTaskNumber() : FormlyFieldConfig {
			return {
			  "key": "TaskNumber",
			  "name": "TaskNumber",
			  "templateOptions": {
			    "label": "TaskNumber"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				GetWorkPackTaskListReferenceCommandRequest.FormlyConfigProPakProjectId,
				GetWorkPackTaskListReferenceCommandRequest.FormlyConfigTaskNumber
			];
		};
	}

	export class HasNewSystemUpdatesCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ImportPrimaveraP6CommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ImportReadinessToolCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class ImportSiteSenseCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class IsUserAuthenticatedCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class LoginCommandRequest {
		Username: string;
		Password: string;
		ServiceToken: string;

		static get FormlyConfigUsername() : FormlyFieldConfig {
			return {
			  "key": "Username",
			  "name": "Username",
			  "templateOptions": {
			    "label": "Username"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPassword() : FormlyFieldConfig {
			return {
			  "key": "Password",
			  "name": "Password",
			  "templateOptions": {
			    "label": "Password"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigServiceToken() : FormlyFieldConfig {
			return {
			  "key": "ServiceToken",
			  "name": "ServiceToken",
			  "templateOptions": {
			    "label": "ServiceToken"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LoginCommandRequest.FormlyConfigUsername,
				LoginCommandRequest.FormlyConfigPassword,
				LoginCommandRequest.FormlyConfigServiceToken
			];
		};
	}

	export class LogoutCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class LogTimeInCommandRequest {
		ProjectId: number;
		AccessArea: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigAccessArea() : FormlyFieldConfig {
			return {
			  "key": "AccessArea",
			  "name": "AccessArea",
			  "templateOptions": {
			    "label": "AccessArea"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LogTimeInCommandRequest.FormlyConfigProjectId,
				LogTimeInCommandRequest.FormlyConfigAccessArea
			];
		};
	}

	export class LogTimeOutCommandRequest {
		ProjectId: number;
		TimeOut: Date;
		IsAutoRouted: boolean;
		AccessArea: string;

		static get FormlyConfigProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProjectId",
			  "name": "ProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigTimeOut() : FormlyFieldConfig {
			return {
			  "key": "TimeOut",
			  "name": "TimeOut",
			  "templateOptions": {
			    "type": "Date",
			    "label": "TimeOut"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIsAutoRouted() : FormlyFieldConfig {
			return {
			  "key": "IsAutoRouted",
			  "name": "IsAutoRouted",
			  "templateOptions": {
			    "label": "IsAutoRouted"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigAccessArea() : FormlyFieldConfig {
			return {
			  "key": "AccessArea",
			  "name": "AccessArea",
			  "templateOptions": {
			    "label": "AccessArea"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LogTimeOutCommandRequest.FormlyConfigProjectId,
				LogTimeOutCommandRequest.FormlyConfigTimeOut,
				LogTimeOutCommandRequest.FormlyConfigIsAutoRouted,
				LogTimeOutCommandRequest.FormlyConfigAccessArea
			];
		};
	}

	export class LogTypeScriptErrorCommandRequest {
		Message: string;
		Type: string;
		Url: string;
		Stack: string;

		static get FormlyConfigMessage() : FormlyFieldConfig {
			return {
			  "key": "Message",
			  "name": "Message",
			  "templateOptions": {
			    "label": "Message"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigType() : FormlyFieldConfig {
			return {
			  "key": "Type",
			  "name": "Type",
			  "templateOptions": {
			    "label": "Type"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigUrl() : FormlyFieldConfig {
			return {
			  "key": "Url",
			  "name": "Url",
			  "templateOptions": {
			    "label": "Url"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigStack() : FormlyFieldConfig {
			return {
			  "key": "Stack",
			  "name": "Stack",
			  "templateOptions": {
			    "label": "Stack"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				LogTypeScriptErrorCommandRequest.FormlyConfigMessage,
				LogTypeScriptErrorCommandRequest.FormlyConfigType,
				LogTypeScriptErrorCommandRequest.FormlyConfigUrl,
				LogTypeScriptErrorCommandRequest.FormlyConfigStack
			];
		};
	}

	export class MarkSystemUpdateCommandRequest {
		SystemUpdateId: number;

		static get FormlyConfigSystemUpdateId() : FormlyFieldConfig {
			return {
			  "key": "SystemUpdateId",
			  "name": "SystemUpdateId",
			  "templateOptions": {
			    "type": "number",
			    "label": "SystemUpdateId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				MarkSystemUpdateCommandRequest.FormlyConfigSystemUpdateId
			];
		};
	}

	export class PersistProjectSetupCommandRequest {
		ProjectInfo: ProjectSetupDto = new ProjectSetupDto();

		static get FormlyConfigProjectInfo() : FormlyFieldConfig {
			return {
			  "key": "ProjectInfo",
			  "name": "ProjectInfo",
			  "templateOptions": {
			    "type": "ProjectSetupDto = new ProjectSetupDto()",
			    "label": "ProjectInfo"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				PersistProjectSetupCommandRequest.FormlyConfigProjectInfo
			];
		};
	}

	export class ReadinessAdminDataCommandRequest {
		ProPakProjectId: number;
		IncludeHiddenColumns: boolean;

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigIncludeHiddenColumns() : FormlyFieldConfig {
			return {
			  "key": "IncludeHiddenColumns",
			  "name": "IncludeHiddenColumns",
			  "templateOptions": {
			    "label": "IncludeHiddenColumns"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				ReadinessAdminDataCommandRequest.FormlyConfigProPakProjectId,
				ReadinessAdminDataCommandRequest.FormlyConfigIncludeHiddenColumns
			];
		};
	}

	export class SaveAdminCommandRequest {
		ProPakProjectId: number;
		Priorities: ProjectPriorityDto[] = [];
		TARApprovals: ProjectTARApprovalDto[] = [];
		HeightAccesses: ProjectHeightAccessDto[] = [];
		IsolationPlans: ProjectIsolationPlanDto[] = [];
		WorkPackRequired: ProjectWorkPackRequiredDto[] = [];
		Revs: ProjectRevDto[] = [];
		MaterialStatuses: ProjectMaterialStatusDto[] = [];
		Fabrications: ProjectFabricationDto[] = [];
		MOCStatuses: ProjectMOCStatusDto[] = [];
		StagedOnSites: ProjectStagedOnSiteDto[] = [];

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigPriorities() : FormlyFieldConfig {
			return {
			  "key": "Priorities",
			  "name": "Priorities",
			  "templateOptions": {
			    "label": "Priorities",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigTARApprovals() : FormlyFieldConfig {
			return {
			  "key": "TARApprovals",
			  "name": "TARApprovals",
			  "templateOptions": {
			    "label": "TARApprovals",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigHeightAccesses() : FormlyFieldConfig {
			return {
			  "key": "HeightAccesses",
			  "name": "HeightAccesses",
			  "templateOptions": {
			    "label": "HeightAccesses",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigIsolationPlans() : FormlyFieldConfig {
			return {
			  "key": "IsolationPlans",
			  "name": "IsolationPlans",
			  "templateOptions": {
			    "label": "IsolationPlans",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigWorkPackRequired() : FormlyFieldConfig {
			return {
			  "key": "WorkPackRequired",
			  "name": "WorkPackRequired",
			  "templateOptions": {
			    "label": "WorkPackRequired",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigRevs() : FormlyFieldConfig {
			return {
			  "key": "Revs",
			  "name": "Revs",
			  "templateOptions": {
			    "label": "Revs",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigMaterialStatuses() : FormlyFieldConfig {
			return {
			  "key": "MaterialStatuses",
			  "name": "MaterialStatuses",
			  "templateOptions": {
			    "label": "MaterialStatuses",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigFabrications() : FormlyFieldConfig {
			return {
			  "key": "Fabrications",
			  "name": "Fabrications",
			  "templateOptions": {
			    "label": "Fabrications",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigMOCStatuses() : FormlyFieldConfig {
			return {
			  "key": "MOCStatuses",
			  "name": "MOCStatuses",
			  "templateOptions": {
			    "label": "MOCStatuses",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigStagedOnSites() : FormlyFieldConfig {
			return {
			  "key": "StagedOnSites",
			  "name": "StagedOnSites",
			  "templateOptions": {
			    "label": "StagedOnSites",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveAdminCommandRequest.FormlyConfigProPakProjectId,
				SaveAdminCommandRequest.FormlyConfigPriorities,
				SaveAdminCommandRequest.FormlyConfigTARApprovals,
				SaveAdminCommandRequest.FormlyConfigHeightAccesses,
				SaveAdminCommandRequest.FormlyConfigIsolationPlans,
				SaveAdminCommandRequest.FormlyConfigWorkPackRequired,
				SaveAdminCommandRequest.FormlyConfigRevs,
				SaveAdminCommandRequest.FormlyConfigMaterialStatuses,
				SaveAdminCommandRequest.FormlyConfigFabrications,
				SaveAdminCommandRequest.FormlyConfigMOCStatuses,
				SaveAdminCommandRequest.FormlyConfigStagedOnSites
			];
		};
	}

	export class SaveApplicationSettingCommandRequest {
		Id: number;
		Name: string;
		Value: string;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigName() : FormlyFieldConfig {
			return {
			  "key": "Name",
			  "name": "Name",
			  "templateOptions": {
			    "label": "Name"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveApplicationSettingCommandRequest.FormlyConfigId,
				SaveApplicationSettingCommandRequest.FormlyConfigName,
				SaveApplicationSettingCommandRequest.FormlyConfigValue
			];
		};
	}

	export class SaveArchiveTaskCommandRequest {
		ArchiveTasks: ReadinessData[] = [];
		ChangedFields: ChangedRowDto[] = [];
		ProPakProjectId: number;

		static get FormlyConfigArchiveTasks() : FormlyFieldConfig {
			return {
			  "key": "ArchiveTasks",
			  "name": "ArchiveTasks",
			  "templateOptions": {
			    "label": "ArchiveTasks",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigChangedFields() : FormlyFieldConfig {
			return {
			  "key": "ChangedFields",
			  "name": "ChangedFields",
			  "templateOptions": {
			    "label": "ChangedFields",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveArchiveTaskCommandRequest.FormlyConfigArchiveTasks,
				SaveArchiveTaskCommandRequest.FormlyConfigChangedFields,
				SaveArchiveTaskCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class SaveCheckpointCommandRequest {
		Roles: ValueTextSelectedDto[] = [];
		SecurityCheckpoint: SecurityCheckpointDto = new SecurityCheckpointDto();

		static get FormlyConfigRoles() : FormlyFieldConfig {
			return {
			  "key": "Roles",
			  "name": "Roles",
			  "templateOptions": {
			    "label": "Roles",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigSecurityCheckpoint() : FormlyFieldConfig {
			return {
			  "key": "SecurityCheckpoint",
			  "name": "SecurityCheckpoint",
			  "templateOptions": {
			    "type": "SecurityCheckpointDto = new SecurityCheckpointDto()",
			    "label": "SecurityCheckpoint"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveCheckpointCommandRequest.FormlyConfigRoles,
				SaveCheckpointCommandRequest.FormlyConfigSecurityCheckpoint
			];
		};
	}

	export class SaveCountryCommandRequest {
		Country: CountryDto = new CountryDto();

		static get FormlyConfigCountry() : FormlyFieldConfig {
			return {
			  "key": "Country",
			  "name": "Country",
			  "templateOptions": {
			    "type": "CountryDto = new CountryDto()",
			    "label": "Country"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveCountryCommandRequest.FormlyConfigCountry
			];
		};
	}

	export class SaveExampleCommandRequest {
		Id: number;
		DisplayText: string;
		Value: string;
		ExampleLookupId: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayText() : FormlyFieldConfig {
			return {
			  "key": "DisplayText",
			  "name": "DisplayText",
			  "templateOptions": {
			    "label": "DisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExampleLookupId() : FormlyFieldConfig {
			return {
			  "key": "ExampleLookupId",
			  "name": "ExampleLookupId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ExampleLookupId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveExampleCommandRequest.FormlyConfigId,
				SaveExampleCommandRequest.FormlyConfigDisplayText,
				SaveExampleCommandRequest.FormlyConfigValue,
				SaveExampleCommandRequest.FormlyConfigExampleLookupId
			];
		};
	}

	export class SaveFormlyExampleCommandRequest {
		Id: number;
		DisplayText: string;
		Value: string;
		ExampleLookupId: number;

		static get FormlyConfigId() : FormlyFieldConfig {
			return {
			  "key": "Id",
			  "name": "Id",
			  "templateOptions": {
			    "type": "number",
			    "label": "Id"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigDisplayText() : FormlyFieldConfig {
			return {
			  "key": "DisplayText",
			  "name": "DisplayText",
			  "templateOptions": {
			    "label": "DisplayText"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigValue() : FormlyFieldConfig {
			return {
			  "key": "Value",
			  "name": "Value",
			  "templateOptions": {
			    "label": "Value"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigExampleLookupId() : FormlyFieldConfig {
			return {
			  "key": "ExampleLookupId",
			  "name": "ExampleLookupId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ExampleLookupId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveFormlyExampleCommandRequest.FormlyConfigId,
				SaveFormlyExampleCommandRequest.FormlyConfigDisplayText,
				SaveFormlyExampleCommandRequest.FormlyConfigValue,
				SaveFormlyExampleCommandRequest.FormlyConfigExampleLookupId
			];
		};
	}

	export class SaveReadinessAdminDataCommandRequest {
		ReadinessTableData: ReadinessColumnDataDto[] = [];
		ProPakProjectId: number;

		static get FormlyConfigReadinessTableData() : FormlyFieldConfig {
			return {
			  "key": "ReadinessTableData",
			  "name": "ReadinessTableData",
			  "templateOptions": {
			    "label": "ReadinessTableData",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveReadinessAdminDataCommandRequest.FormlyConfigReadinessTableData,
				SaveReadinessAdminDataCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class SaveReadinessCommandRequest {
		Readiness: ReadinessData[] = [];
		CreateNewTask: boolean;
		ChangedFields: ChangedRowDto[] = [];
		ProPakProjectId: number;

		static get FormlyConfigReadiness() : FormlyFieldConfig {
			return {
			  "key": "Readiness",
			  "name": "Readiness",
			  "templateOptions": {
			    "label": "Readiness",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigCreateNewTask() : FormlyFieldConfig {
			return {
			  "key": "CreateNewTask",
			  "name": "CreateNewTask",
			  "templateOptions": {
			    "label": "CreateNewTask"
			  },
			  "type": "checkbox"
			};
		};

		static get FormlyConfigChangedFields() : FormlyFieldConfig {
			return {
			  "key": "ChangedFields",
			  "name": "ChangedFields",
			  "templateOptions": {
			    "label": "ChangedFields",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveReadinessCommandRequest.FormlyConfigReadiness,
				SaveReadinessCommandRequest.FormlyConfigCreateNewTask,
				SaveReadinessCommandRequest.FormlyConfigChangedFields,
				SaveReadinessCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class SaveReadinessTaskAttachmentsCommandRequest {
		ProjectTaskId: number;
		NewAttachments: NewReadinessTaskAttachmentDto[] = [];
		DeleteAttachmentIds: number[] = [];

		static get FormlyConfigProjectTaskId() : FormlyFieldConfig {
			return {
			  "key": "ProjectTaskId",
			  "name": "ProjectTaskId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProjectTaskId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigNewAttachments() : FormlyFieldConfig {
			return {
			  "key": "NewAttachments",
			  "name": "NewAttachments",
			  "templateOptions": {
			    "label": "NewAttachments",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigDeleteAttachmentIds() : FormlyFieldConfig {
			return {
			  "key": "DeleteAttachmentIds",
			  "name": "DeleteAttachmentIds",
			  "templateOptions": {
			    "label": "DeleteAttachmentIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveReadinessTaskAttachmentsCommandRequest.FormlyConfigProjectTaskId,
				SaveReadinessTaskAttachmentsCommandRequest.FormlyConfigNewAttachments,
				SaveReadinessTaskAttachmentsCommandRequest.FormlyConfigDeleteAttachmentIds
			];
		};
	}

	export class SaveReadinessTrafficLightRuleCommandRequest {
		ReadinessTrafficLightData: ReadinessTrafficLightRuleDto[] = [];
		ProPakProjectId: number;

		static get FormlyConfigReadinessTrafficLightData() : FormlyFieldConfig {
			return {
			  "key": "ReadinessTrafficLightData",
			  "name": "ReadinessTrafficLightData",
			  "templateOptions": {
			    "label": "ReadinessTrafficLightData",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfigProPakProjectId() : FormlyFieldConfig {
			return {
			  "key": "ProPakProjectId",
			  "name": "ProPakProjectId",
			  "templateOptions": {
			    "type": "number",
			    "label": "ProPakProjectId"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveReadinessTrafficLightRuleCommandRequest.FormlyConfigReadinessTrafficLightData,
				SaveReadinessTrafficLightRuleCommandRequest.FormlyConfigProPakProjectId
			];
		};
	}

	export class SaveRoleCommandRequest {
		Role: RoleDto = new RoleDto();
		RoleWidgets: ValueTextSelectedDto[] = [];

		static get FormlyConfigRole() : FormlyFieldConfig {
			return {
			  "key": "Role",
			  "name": "Role",
			  "templateOptions": {
			    "type": "RoleDto = new RoleDto()",
			    "label": "Role"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigRoleWidgets() : FormlyFieldConfig {
			return {
			  "key": "RoleWidgets",
			  "name": "RoleWidgets",
			  "templateOptions": {
			    "label": "RoleWidgets",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveRoleCommandRequest.FormlyConfigRole,
				SaveRoleCommandRequest.FormlyConfigRoleWidgets
			];
		};
	}

	export class SaveUserCommandRequest {
		UserDto: UserDto = new UserDto();

		static get FormlyConfigUserDto() : FormlyFieldConfig {
			return {
			  "key": "UserDto",
			  "name": "UserDto",
			  "templateOptions": {
			    "type": "UserDto = new UserDto()",
			    "label": "UserDto"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveUserCommandRequest.FormlyConfigUserDto
			];
		};
	}

	export class SaveUserWidgetOrderCommandRequest {
		WidgetIds: number[] = [];

		static get FormlyConfigWidgetIds() : FormlyFieldConfig {
			return {
			  "key": "WidgetIds",
			  "name": "WidgetIds",
			  "templateOptions": {
			    "label": "WidgetIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveUserWidgetOrderCommandRequest.FormlyConfigWidgetIds
			];
		};
	}

	export class SaveUserWidgetSelectionsCommandRequest {
		SelectedWidgetIds: number[] = [];

		static get FormlyConfigSelectedWidgetIds() : FormlyFieldConfig {
			return {
			  "key": "SelectedWidgetIds",
			  "name": "SelectedWidgetIds",
			  "templateOptions": {
			    "label": "SelectedWidgetIds",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SaveUserWidgetSelectionsCommandRequest.FormlyConfigSelectedWidgetIds
			];
		};
	}

	export class SearchObjectsCommandRequest {
		SearchCriteria: SearchCriteria = new SearchCriteria();
		Objects: any[] = [];

		static get FormlyConfigSearchCriteria() : FormlyFieldConfig {
			return {
			  "key": "SearchCriteria",
			  "name": "SearchCriteria",
			  "templateOptions": {
			    "type": "SearchCriteria = new SearchCriteria()",
			    "label": "SearchCriteria"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigObjects() : FormlyFieldConfig {
			return {
			  "key": "Objects",
			  "name": "Objects",
			  "templateOptions": {
			    "label": "Objects",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				SearchObjectsCommandRequest.FormlyConfigSearchCriteria,
				SearchObjectsCommandRequest.FormlyConfigObjects
			];
		};
	}

	export class TestDummyCommandRequest {
		MyString: string;
		MyInt: number;
		MyNullableInt: number;

		static get FormlyConfigMyString() : FormlyFieldConfig {
			return {
			  "key": "MyString",
			  "name": "MyString",
			  "templateOptions": {
			    "label": "MyString"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMyInt() : FormlyFieldConfig {
			return {
			  "key": "MyInt",
			  "name": "MyInt",
			  "templateOptions": {
			    "type": "number",
			    "label": "MyInt"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigMyNullableInt() : FormlyFieldConfig {
			return {
			  "key": "MyNullableInt",
			  "name": "MyNullableInt",
			  "templateOptions": {
			    "type": "number",
			    "label": "MyNullableInt"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				TestDummyCommandRequest.FormlyConfigMyString,
				TestDummyCommandRequest.FormlyConfigMyInt,
				TestDummyCommandRequest.FormlyConfigMyNullableInt
			];
		};
	}

	export class TriggerServerExceptionCommandRequest {

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [

			];
		};
	}

	export class UnArchiveProjectTasksCommandRequest {
		ArchiveTasks: ReadinessData[] = [];

		static get FormlyConfigArchiveTasks() : FormlyFieldConfig {
			return {
			  "key": "ArchiveTasks",
			  "name": "ArchiveTasks",
			  "templateOptions": {
			    "label": "ArchiveTasks",
			    "multiple": true
			  },
			  "type": "select"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UnArchiveProjectTasksCommandRequest.FormlyConfigArchiveTasks
			];
		};
	}

	export class UnusedSecurityCheckpointSearchCommandRequest {
		SearchType: string;
		SearchCriteria: SearchCriteria = new SearchCriteria();

		static get FormlyConfigSearchType() : FormlyFieldConfig {
			return {
			  "key": "SearchType",
			  "name": "SearchType",
			  "templateOptions": {
			    "label": "SearchType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigSearchCriteria() : FormlyFieldConfig {
			return {
			  "key": "SearchCriteria",
			  "name": "SearchCriteria",
			  "templateOptions": {
			    "type": "SearchCriteria = new SearchCriteria()",
			    "label": "SearchCriteria"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UnusedSecurityCheckpointSearchCommandRequest.FormlyConfigSearchType,
				UnusedSecurityCheckpointSearchCommandRequest.FormlyConfigSearchCriteria
			];
		};
	}

	export class UpdateSupportTicketStatusCommandRequest {
		supportTicket: SupportTicketDto = new SupportTicketDto();

		static get FormlyConfigsupportTicket() : FormlyFieldConfig {
			return {
			  "key": "supportTicket",
			  "name": "supportTicket",
			  "templateOptions": {
			    "type": "SupportTicketDto = new SupportTicketDto()",
			    "label": "supportTicket"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UpdateSupportTicketStatusCommandRequest.FormlyConfigsupportTicket
			];
		};
	}

	export class UploadReadinessAttachmentCommandRequest {
		FileBase64: string;
		FileName: string;
		FileType: string;

		static get FormlyConfigFileBase64() : FormlyFieldConfig {
			return {
			  "key": "FileBase64",
			  "name": "FileBase64",
			  "templateOptions": {
			    "label": "FileBase64"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileName() : FormlyFieldConfig {
			return {
			  "key": "FileName",
			  "name": "FileName",
			  "templateOptions": {
			    "label": "FileName"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfigFileType() : FormlyFieldConfig {
			return {
			  "key": "FileType",
			  "name": "FileType",
			  "templateOptions": {
			    "label": "FileType"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UploadReadinessAttachmentCommandRequest.FormlyConfigFileBase64,
				UploadReadinessAttachmentCommandRequest.FormlyConfigFileName,
				UploadReadinessAttachmentCommandRequest.FormlyConfigFileType
			];
		};
	}

	export class UploadReadinessImageCommandRequest {
		ImageBase64: string;

		static get FormlyConfigImageBase64() : FormlyFieldConfig {
			return {
			  "key": "ImageBase64",
			  "name": "ImageBase64",
			  "templateOptions": {
			    "label": "ImageBase64"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UploadReadinessImageCommandRequest.FormlyConfigImageBase64
			];
		};
	}

	export class UserSessionsCommandRequest {
		Filter: UserSessionFilter = new UserSessionFilter();

		static get FormlyConfigFilter() : FormlyFieldConfig {
			return {
			  "key": "Filter",
			  "name": "Filter",
			  "templateOptions": {
			    "type": "UserSessionFilter = new UserSessionFilter()",
			    "label": "Filter"
			  },
			  "type": "input"
			};
		};

		static get FormlyConfig() : FormlyFieldConfig[] {
			return [
				UserSessionsCommandRequest.FormlyConfigFilter
			];
		};
	}

	export class AddUpdateSupportTicketCommandResponse {
		SupportTicket: SupportTicketDto = new SupportTicketDto();
	}

	export class AdminCommandResponse {
		ProjectPhases: ProjectPhaseDto[] = [];
		Priorities: ProjectPriorityDto[] = [];
		TARApprovals: ProjectTARApprovalDto[] = [];
		HeightAccesses: ProjectHeightAccessDto[] = [];
		IsolationPlans: ProjectIsolationPlanDto[] = [];
		WorkPackRequired: ProjectWorkPackRequiredDto[] = [];
		Revs: ProjectRevDto[] = [];
		MaterialStatuses: ProjectMaterialStatusDto[] = [];
		Fabrications: ProjectFabricationDto[] = [];
		MOCStatuses: ProjectMOCStatusDto[] = [];
		StagedOnSites: ProjectStagedOnSiteDto[] = [];
	}

	export class AskDataQuestionCommandResponse {
		Answer: string;
		Sql: string;
		Columns: string[] = [];
		Rows: AskDataRowDto[] = [];
		RowCount: number;
		Truncated: boolean;
	}

	export class CreateReadinessExcelReportCommandResponse {
		ReadinessReport: Blob;
		FileName: string;
		ReportData: string;
	}

	export class CreateReadinessPdfReportCommandResponse {
		ReadinessReport: Blob;
		FileName: string;
		ReportData: string;
	}

	export class CreateTestDummyCommandQueueCommandResponse {
	}

	export class CreateUserCommandResponse {
	}

	export class DeleteArchiveProjectTasksCommandResponse {
		isDeleted: boolean;
	}

	export class DeleteCheckpointCommandResponse {
	}

	export class DeleteReadinessImageCommandResponse {
		IsDeleted: boolean;
	}

	export class DeleteReadinessTaskCommandResponse {
		Id: number;
	}

	export class DeleteRoleCommandResponse {
	}

	export class ExecuteAllPendingQueuesCommandResponse {
	}

	export class ExecuteNextQueueEntryCommandResponse {
		ProcessedQueueEntryId: number;
		WasAQueueEntryProcessed: boolean;
	}

	export class ExecutePendingQueueEntriesCommandResponse {
	}

	export class ExportUserSessionsExcelCommandResponse {
		FileBytes: Blob;
		FileName: string;
	}

	export class GetApplicationSettingCommandResponse {
		Id: number;
		Name: string;
		Value: string;
	}

	export class GetArchiveTaskCommandResponse {
		ArchiveTasks: ReadinessData[] = [];
	}

	export class GetCheckpointCommandResponse {
		Roles: ValueTextSelectedDto[] = [];
		SecurityCheckpoint: SecurityCheckpointDto = new SecurityCheckpointDto();
	}

	export class GetClientAndAssetListByUserCommandResponse {
		AssetList: AssetDto[] = [];
		ClientList: ClientDto[] = [];
	}

	export class GetCountryCommandResponse {
		Country: CountryDto = new CountryDto();
	}

	export class GetDashboardCommandResponse {
		Dashboard: DashboardDto = new DashboardDto();
	}

	export class GetExampleCommandResponse {
		Id: number;
		DisplayText: string;
		Value: string;
		ExampleLookupId: number;
		ExampleLookups: ValueLabelDto[] = [];
	}

	export class GetExceptionCommandResponse {
		Id: number;
		CreationDate: string;
		ApplicationName: string;
		MachineName: string;
		Type: string;
		User: string;
		URL: string;
		HTTPMethod: string;
		Message: string;
		Detail: string;
	}

	export class GetExecutionBarChartCommandResponse {
		Data: ExecutionChartDataSeriesDto[] = [];
	}

	export class GetExecutionChartCommandResponse {
		Data: ExecutionScheduleDto = new ExecutionScheduleDto();
	}

	export class GetExecutionCurrentStatusChartCommandResponse {
		Data: ExecutionBarChartDto = new ExecutionBarChartDto();
	}

	export class GetExecutionStatusCommandResponse {
		Execution: ExecutionSummaryDto = new ExecutionSummaryDto();
	}

	export class GetFeatureCommandResponse {
		NewUpdates: SystemUpdateDto[] = [];
		PastUpdates: SystemUpdateDto[] = [];
	}

	export class GetMaterialsStatusCommandResponse {
		Materials: MaterialsStageStatusDto = new MaterialsStageStatusDto();
	}

	export class GetP6ReportingLinkCommandResponse {
		Url: string;
	}

	export class GetPrimaveraSummaryReportCommandResponse {
		Data: TaskDto[] = [];
		Links: LinkDto[] = [];
	}

	export class GetProjectAiInsightsCommandResponse {
		Insights: string;
		GeneratedAtUtc: Date;
	}

	export class GetProjectCardMetricsCommandResponse {
		Metrics: ProjectCardMetricsDto[] = [];
		CacheHits: number;
		CacheMisses: number;
		ElapsedMilliseconds: number;
	}

	export class GetProjectModuleDisplaySettingsCommandResponse {
		ModuleDisplaySettings: ModuleDisplaySettingDto = new ModuleDisplaySettingDto();
	}

	export class GetProjectsByUserCommandResponse {
		Projects: ProjectDto[] = [];
		FavoriteProjects: ProjectDto[] = [];
		TotalCount: number;
		AssetList: AssetDto[] = [];
		ClientList: ClientDto[] = [];
		UserRoles: UserRoleDto[] = [];
	}

	export class GetProjectsByUserSessionCommandResponse {
		Result: ProjectAccessPagedResponse = new ProjectAccessPagedResponse();
	}

	export class GetProjectSetupCommandResponse {
		ProjectInfo: ProjectSetupDto = new ProjectSetupDto();
	}

	export class GetQueueDetailCommandResponse {
	}

	export class GetReadinessFormDataCommandResponse {
		ReadinessFormData: ReadinessData[] = [];
	}

	export class GetReadinessStatusCommandResponse {
		Readiness: StageStatusDto = new StageStatusDto();
	}

	export class GetReadinessSummaryCommandResponse {
		ReadinessSummary: ReadinessSummaryDto = new ReadinessSummaryDto();
	}

	export class GetReadinessTaskAttachmentCountsCommandResponse {
		Counts: ReadinessTaskAttachmentCountDto[] = [];
	}

	export class GetReadinessTaskAttachmentsCommandResponse {
		Attachments: ReadinessTaskAttachmentItemDto[] = [];
	}

	export class GetReadinessTrafficLightRuleCommandResponse {
		ReadinessTrafficLightData: ReadinessTrafficLightRuleDto[] = [];
	}

	export class GetReleaseNumberCommandResponse {
		ReleaseId: string;
	}

	export class GetRoleCommandResponse {
		Role: RoleDto = new RoleDto();
		RoleWidgets: ValueTextSelectedDto[] = [];
	}

	export class GetSessionUsersCommandResponse {
		Result: UserDto[] = [];
	}

	export class GetSupportTicketCommandResponse {
		SupportTickets: SupportTicketDto[] = [];
		TotalItems: number;
	}

	export class GetSystemUpdateCommandResponse {
		SystemUpdate: SystemUpdateDto = new SystemUpdateDto();
	}

	export class GetTaskPriorityStatusCommandResponse {
		PrioritySummary: ProjectPrioritySummaryDto = new ProjectPrioritySummaryDto();
	}

	export class GetUserCommandResponse {
		UserDto: UserDto = new UserDto();
	}

	export class GetUserWidgetSelectionsCommandResponse {
		Widgets: WidgetDto[] = [];
	}

	export class GetWorkpacksByProjectCommandResponse {
		WorkPacks: WorkPackDto[] = [];
	}

	export class GetWorkPackTaskListReferenceCommandResponse {
		WorkPackId: number;
		WorkPackNumber: string;
		TaskId: number;
		TaskNumber: string;
		Revision: string;
		TaskImageUrl: string;
	}

	export class HasNewSystemUpdatesCommandResponse {
		HasNewUpdates: boolean;
	}

	export class ImportPrimaveraP6CommandResponse {
	}

	export class ImportReadinessToolCommandResponse {
	}

	export class ImportSiteSenseCommandResponse {
		ProcessedProjects: SiteSenseProjectDto[] = [];
		BypassedProjects: SiteSenseProjectDto[] = [];
	}

	export class IsUserAuthenticatedCommandResponse {
		IsAuthenticated: boolean;
		UserInfo: UserInfoDto = new UserInfoDto();
	}

	export class LoginCommandResponse {
		UserInfo: UserInfoDto = new UserInfoDto();
	}

	export class LogTimeInCommandResponse {
		Result: number;
	}

	export class LogTimeOutCommandResponse {
		Result: number;
	}

	export class MarkSystemUpdateCommandResponse {
		SystemUpdateLogId: number;
	}

	export class PersistProjectSetupCommandResponse {
		ProjectInfo: ProjectSetupDto = new ProjectSetupDto();
	}

	export class ReadinessAdminDataCommandResponse {
		ReadinessTableData: ReadinessColumnDataDto[] = [];
		ProPakProjectId: number;
	}

	export class SaveAdminCommandResponse {
		IsRecordsUpdated: boolean;
	}

	export class SaveApplicationSettingCommandResponse {
		Id: number;
	}

	export class SaveArchiveTaskCommandResponse {
		Id: number;
	}

	export class SaveCheckpointCommandResponse {
		Id: number;
	}

	export class SaveCountryCommandResponse {
		Id: number;
	}

	export class SaveExampleCommandResponse {
		Id: number;
	}

	export class SaveFormlyExampleCommandResponse {
		Id: number;
	}

	export class SaveReadinessAdminDataCommandResponse {
		ReadinessTableData: ReadinessColumnDataDto[] = [];
	}

	export class SaveReadinessCommandResponse {
		Id: number;
		Message: string;
	}

	export class SaveReadinessTaskAttachmentsCommandResponse {
		Success: boolean;
		Attachments: ReadinessTaskAttachmentDto[] = [];
	}

	export class SaveReadinessTrafficLightRuleCommandResponse {
		ReadinessTrafficLightData: ReadinessTrafficLightRuleDto[] = [];
	}

	export class SaveRoleCommandResponse {
		Id: number;
	}

	export class SaveUserCommandResponse {
		Id: number;
	}

	export class SaveUserWidgetOrderCommandResponse {
	}

	export class SaveUserWidgetSelectionsCommandResponse {
	}

	export class SearchObjectsCommandResponse {
		Results: IPagedResult;
	}

	export class TestDummyCommandResponse {
		MyString: string;
		MyInt: number;
		MyNullableInt: number;
	}

	export class TriggerServerExceptionCommandResponse {
	}

	export class UnArchiveProjectTasksCommandResponse {
		Id: number;
	}

	export class UnusedSecurityCheckpointSearchCommandResponse {
		PagedResult: IPagedResult;
		Columns: ColumnInformation[] = [];
	}

	export class UpdateSupportTicketStatusCommandResponse {
		SupportTicket: SupportTicketDto = new SupportTicketDto();
	}

	export class UploadReadinessAttachmentCommandResponse {
		AttachmentUrl: string;
		FileName: string;
	}

	export class UploadReadinessImageCommandResponse {
		ImageUrl: string;
	}

	export class UserSessionsCommandResponse {
		result: PagedResponse = new PagedResponse();
	}

	export enum BatchProcessingQueueDefinition {
		TestDummy = 1,
		Email = 2,
	}

	export enum QueueEntryStatus {
		Pending = 0,
		Executing = 1,
		CompletedSuccessfully = 2,
		CompletedWithError = 3,
	}

	export enum CacheDomain {
		ProjectCardMetrics = 0,
		Execution = 1,
		Readiness = 2,
		Materials = 3,
		ProjectSetup = 4,
		Commissioning = 5,
	}

	export enum WidgetType {
		Count = 0,
	}

	export enum SectionTone {
		Completed = 0,
		InProgress = 1,
		NotStarted = 2,
	}

	export let BatchProcessingQueueDefinitionDisplayOptions = [
		{ name: "TestDummy", value: "TestDummy", enum: BatchProcessingQueueDefinition.TestDummy },
		{ name: "Email", value: "Email", enum: BatchProcessingQueueDefinition.Email },
	];

	export let QueueEntryStatusDisplayOptions = [
		{ name: "Pending", value: "Pending", enum: QueueEntryStatus.Pending },
		{ name: "Executing", value: "Executing", enum: QueueEntryStatus.Executing },
		{ name: "CompletedSuccessfully", value: "CompletedSuccessfully", enum: QueueEntryStatus.CompletedSuccessfully },
		{ name: "CompletedWithError", value: "CompletedWithError", enum: QueueEntryStatus.CompletedWithError },
	];

	export let CacheDomainDisplayOptions = [
		{ name: "ProjectCardMetrics", value: "ProjectCardMetrics", enum: CacheDomain.ProjectCardMetrics },
		{ name: "Execution", value: "Execution", enum: CacheDomain.Execution },
		{ name: "Readiness", value: "Readiness", enum: CacheDomain.Readiness },
		{ name: "Materials", value: "Materials", enum: CacheDomain.Materials },
		{ name: "ProjectSetup", value: "ProjectSetup", enum: CacheDomain.ProjectSetup },
		{ name: "Commissioning", value: "Commissioning", enum: CacheDomain.Commissioning },
	];

	export let WidgetTypeDisplayOptions = [
		{ name: "Count", value: "Count", enum: WidgetType.Count },
	];

	export let SectionToneDisplayOptions = [
		{ name: "Completed", value: "Completed", enum: SectionTone.Completed },
		{ name: "InProgress", value: "InProgress", enum: SectionTone.InProgress },
		{ name: "NotStarted", value: "NotStarted", enum: SectionTone.NotStarted },
	];

	export let BatchProcessingQueueDefinitionDisplayMap = {
		[BatchProcessingQueueDefinition.TestDummy]: "TestDummy",
		[BatchProcessingQueueDefinition.Email]: "Email",
	};

	export let QueueEntryStatusDisplayMap = {
		[QueueEntryStatus.Pending]: "Pending",
		[QueueEntryStatus.Executing]: "Executing",
		[QueueEntryStatus.CompletedSuccessfully]: "CompletedSuccessfully",
		[QueueEntryStatus.CompletedWithError]: "CompletedWithError",
	};

	export let CacheDomainDisplayMap = {
		[CacheDomain.ProjectCardMetrics]: "ProjectCardMetrics",
		[CacheDomain.Execution]: "Execution",
		[CacheDomain.Readiness]: "Readiness",
		[CacheDomain.Materials]: "Materials",
		[CacheDomain.ProjectSetup]: "ProjectSetup",
		[CacheDomain.Commissioning]: "Commissioning",
	};

	export let WidgetTypeDisplayMap = {
		[WidgetType.Count]: "Count",
	};

	export let SectionToneDisplayMap = {
		[SectionTone.Completed]: "Completed",
		[SectionTone.InProgress]: "InProgress",
		[SectionTone.NotStarted]: "NotStarted",
	};

	export class CommandNames {
		static AddUpdateSupportTicket: String = "AddUpdateSupportTicket"
		static Admin: String = "Admin"
		static AskDataQuestion: String = "AskDataQuestion"
		static CreateReadinessExcelReport: String = "CreateReadinessExcelReport"
		static CreateReadinessPdfReport: String = "CreateReadinessPdfReport"
		static CreateTestDummyCommandQueue: String = "CreateTestDummyCommandQueue"
		static CreateUser: String = "CreateUser"
		static DeleteArchiveProjectTasks: String = "DeleteArchiveProjectTasks"
		static DeleteCheckpoint: String = "DeleteCheckpoint"
		static DeleteExample: String = "DeleteExample"
		static DeleteReadinessImage: String = "DeleteReadinessImage"
		static DeleteReadinessTask: String = "DeleteReadinessTask"
		static DeleteRole: String = "DeleteRole"
		static ExecuteAllPendingQueues: String = "ExecuteAllPendingQueues"
		static ExecuteNextQueueEntry: String = "ExecuteNextQueueEntry"
		static ExecutePendingQueueEntries: String = "ExecutePendingQueueEntries"
		static ExportUserSessionsExcel: String = "ExportUserSessionsExcel"
		static GetApplicationSetting: String = "GetApplicationSetting"
		static GetArchiveTask: String = "GetArchiveTask"
		static GetCheckpoint: String = "GetCheckpoint"
		static GetClientAndAssetListByUser: String = "GetClientAndAssetListByUser"
		static GetCountry: String = "GetCountry"
		static GetDashboard: String = "GetDashboard"
		static GetExample: String = "GetExample"
		static GetException: String = "GetException"
		static GetExecutionBarChart: String = "GetExecutionBarChart"
		static GetExecutionChart: String = "GetExecutionChart"
		static GetExecutionCurrentStatusChart: String = "GetExecutionCurrentStatusChart"
		static GetExecutionStatus: String = "GetExecutionStatus"
		static GetFeature: String = "GetFeature"
		static GetMaterialsStatus: String = "GetMaterialsStatus"
		static GetP6ReportingLink: String = "GetP6ReportingLink"
		static GetPrimaveraSummaryReport: String = "GetPrimaveraSummaryReport"
		static GetProjectAiInsights: String = "GetProjectAiInsights"
		static GetProjectCardMetrics: String = "GetProjectCardMetrics"
		static GetProjectModuleDisplaySettings: String = "GetProjectModuleDisplaySettings"
		static GetProjectsByUser: String = "GetProjectsByUser"
		static GetProjectsByUserSession: String = "GetProjectsByUserSession"
		static GetProjectSetup: String = "GetProjectSetup"
		static GetQueueDetail: String = "GetQueueDetail"
		static GetReadinessFormData: String = "GetReadinessFormData"
		static GetReadinessStatus: String = "GetReadinessStatus"
		static GetReadinessSummary: String = "GetReadinessSummary"
		static GetReadinessTaskAttachmentCounts: String = "GetReadinessTaskAttachmentCounts"
		static GetReadinessTaskAttachments: String = "GetReadinessTaskAttachments"
		static GetReadinessTrafficLightRule: String = "GetReadinessTrafficLightRule"
		static GetReleaseNumber: String = "GetReleaseNumber"
		static GetRole: String = "GetRole"
		static GetSessionUsers: String = "GetSessionUsers"
		static GetSupportTicket: String = "GetSupportTicket"
		static GetSystemUpdate: String = "GetSystemUpdate"
		static GetTaskPriorityStatus: String = "GetTaskPriorityStatus"
		static GetUser: String = "GetUser"
		static GetUserWidgetSelections: String = "GetUserWidgetSelections"
		static GetWorkpacksByProject: String = "GetWorkpacksByProject"
		static GetWorkPackTaskListReference: String = "GetWorkPackTaskListReference"
		static HasNewSystemUpdates: String = "HasNewSystemUpdates"
		static ImportPrimaveraP6: String = "ImportPrimaveraP6"
		static ImportReadinessTool: String = "ImportReadinessTool"
		static ImportSiteSense: String = "ImportSiteSense"
		static IsUserAuthenticated: String = "IsUserAuthenticated"
		static Login: String = "Login"
		static Logout: String = "Logout"
		static LogTimeIn: String = "LogTimeIn"
		static LogTimeOut: String = "LogTimeOut"
		static LogTypeScriptError: String = "LogTypeScriptError"
		static MarkSystemUpdate: String = "MarkSystemUpdate"
		static PersistProjectSetup: String = "PersistProjectSetup"
		static ReadinessAdminData: String = "ReadinessAdminData"
		static SaveAdmin: String = "SaveAdmin"
		static SaveApplicationSetting: String = "SaveApplicationSetting"
		static SaveArchiveTask: String = "SaveArchiveTask"
		static SaveCheckpoint: String = "SaveCheckpoint"
		static SaveCountry: String = "SaveCountry"
		static SaveExample: String = "SaveExample"
		static SaveFormlyExample: String = "SaveFormlyExample"
		static SaveReadinessAdminData: String = "SaveReadinessAdminData"
		static SaveReadiness: String = "SaveReadiness"
		static SaveReadinessTaskAttachments: String = "SaveReadinessTaskAttachments"
		static SaveReadinessTrafficLightRule: String = "SaveReadinessTrafficLightRule"
		static SaveRole: String = "SaveRole"
		static SaveUser: String = "SaveUser"
		static SaveUserWidgetOrder: String = "SaveUserWidgetOrder"
		static SaveUserWidgetSelections: String = "SaveUserWidgetSelections"
		static SearchObjects: String = "SearchObjects"
		static TestDummy: String = "TestDummy"
		static TriggerServerException: String = "TriggerServerException"
		static UnArchiveProjectTasks: String = "UnArchiveProjectTasks"
		static UnusedSecurityCheckpointSearch: String = "UnusedSecurityCheckpointSearch"
		static UpdateSupportTicketStatus: String = "UpdateSupportTicketStatus"
		static UploadReadinessAttachment: String = "UploadReadinessAttachment"
		static UploadReadinessImage: String = "UploadReadinessImage"
		static UserSessions: String = "UserSessions"
	}

